import React from "react";
import { Link } from "react-router-dom";

import {
  Check,
  DashboardIcon,
  Error,
  PatientEMRIcon,
  AddIcon,
  SaveIcon,
  DeleteIcon,
  NationalIdCardIcon,
  LabelIcon,
  VipIcon,
  DiabetesIcon,
  BloodPressureIcon,
  PrintFormIcon,
  CalanderIcon,
  DropDownIconForDataTable,
  DiagnosisIcon,
  FormBuilderIcon,
  ExitIcon,
  UsDollarCurrencyIcon,
  KuwaitDinarCurrencyIcon,
  EmiratiDirhamCurrencyIcon,
  EditIcon,
  ReportsIcons,
  CheckIcon,
  WarningIcon,
  PresentIcon,
  AbsentIcon,
  PatientEmrDeleteIcon,
  StickerIcon,
  FormsIcon,
} from "../components/common/svg-components";

import {
  IAppointmenuHeaderMenu,
  IColorCode,
  IComplianceData,
  ICurrencyValue,
  IDiagnosisStatusData,
  IFormActionSidebar,
  IInterval,
  IModuleList,
  IModuleScreen,
  INotiificationData,
  IRadiologyTab,
  IRangeData,
  ISesstionTimeData,
  ISidebar,
  ITab,
  ITabV2,
  ITagData,
  ITDBData,
} from "../interfaces/interfaces";
import { colors } from "./color";
import { useAppDispatch } from "../hooks";
import { components } from "react-select";
import { TodoAlaramIcon } from "../components/common/svg-components/index";
import paymentCash from "../assets/images/paymentCash.png";
import paymentKnet from "../assets/images/paymentKnet.png";
import paymentDebit from "../assets/images/paymentDebit.png";
import paymentCredit from "../assets/images/paymentCredit.png";
import paymentLoyaltyPoints from "../assets/images/paymentLoyaltyPoints.png";
import ToggleSwitchV2 from "../components/common/toggle-switch/ToggleSwitchV2";
import { getAllMasterValuePayloadData } from "../redux/features/master-value/MasterValueSlice";
import styles from "../constants/table-data/tableData.module.scss";
import IpdTimelineMainLayout from "../pages/ipd/create-ipd-main-layout/ipd-timeline/ipd-timeline-main-layout/IpdTimelineMainLayout";
import Consultation from "../pages/ipd/create-ipd-main-layout/ipd-timeline/consultation/Consultation";
import IpdMedication from "../pages/ipd/create-ipd-main-layout/ipd-timeline/ipd-medication/IpdMedication";
import IpdTest from "../pages/ipd/create-ipd-main-layout/ipd-timeline/ipd-test/IpdTest";
import {
  ABSENT_TODAY,
  ACCOUNT_NO,
  ACCOUNT_SUMMARY,
  COMPLAINT_CODE,
  COMPLETED,
  DEPARTMENT_REVENUE,
  DOCTOR_FEEDBACK,
  DOCTOR_OCCUPANCY,
  DOCTOR_OUTSTANDING,
  DOCTOR_REVENUE,
  HOLIDAY_DATE,
  INVENTORY_DEPARTMENT_REQUESTS,
  INVENTORY_ITEMS,
  IPD_CASE_SUMMARY,
  LAB_JOBS,
  RADIOLOGY_JOBS,
  NEW,
  ON_GOING,
  PATIENT_FEEDBACK,
  PATIENT_SUMMARY,
  PATIENT_VISIT,
  PHARMACY_SUMMARY,
  APPOINTMENT_OCCUPANCY,
  PATIENT_COMPARISON,
} from "./constant";
import moment from "moment";
import { t } from "i18next";
import { report } from "process";

export const DropdownIndicator = (props: any) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <DropDownIconForDataTable />
      </components.DropdownIndicator>
    )
  );
};

/* Options array for searchable select - Attended/New */
export const optionsArrayForStatus = [
  {
    name: "New",
    _id: "new",
  },
  {
    name: "Attended",
    _id: "attended",
  },
];
export const billableDropdownData = [
  {
    name: "Yes",
    _id: true,
  },
  {
    name: "No",
    _id: false,
  },
];
export const billedStatusDropdown = [
  {
    name: "Billed",
    _id: "billed",
  },
  {
    name: "Not Billed",
    _id: "not-billed",
  },
  {
    name: "To Be Billed",
    _id: "to-be-billed",
  },
];

// Form action sidebar
export const formActionData: IFormActionSidebar[] = [
  {
    id: 0,
    name: t("ActionBar.Add"),
    icon: AddIcon,
    handleOnClick: false,
  },
  {
    id: 1,
    name: t("Common.Save"),
    icon: SaveIcon,
    handleOnClick: true,
  },
  {
    id: 2,
    name: t("PatientEMR.Inactive"),
    // icon: DeleteIcon,
    icon: PatientEmrDeleteIcon,
    handleOnClick: true,
  },

  {
    id: 3,
    name: t("ActionBar.Print"),
    icon: PrintFormIcon,
    // handleOnClick: false,
    handleOnClick: true,
  },
  {
    id: 4,
    name: t("ActionBar.NationalID"),
    icon: NationalIdCardIcon,
    handleOnClick: true,
  },
  {
    id: 5,
    name: t("ActionBar.Label"),
    icon: LabelIcon,
    handleOnClick: false,
  },
  {
    id: 6,
    // name: t("ActionBar.Label"),
    name: "Sticker",
    icon: StickerIcon,
    handleOnClick: false,
  },
  {
    id: 7,
    // name: t("ActionBar.Label"),
    name: "Forms",
    icon: FormsIcon,
    handleOnClick: false,
  },
];

// Invoice Form action sidebar
export const invoiceFormActionData: IFormActionSidebar[] = [
  {
    id: 0,
    name: t("ActionBar.Add"),
    icon: AddIcon,
    handleOnClick: true,
  },
  {
    id: 1,
    name: t("Common.Save"),
    icon: SaveIcon,
    handleOnClick: false,
  },
  {
    id: 2,
    name: t("Receptionist Dashboard.Delete"),
    // icon: DeleteIcon,
    icon: PatientEmrDeleteIcon,
    handleOnClick: false,
  },
  {
    id: 3,
    name: t("ActionBar.Print"),
    icon: PrintFormIcon,
    handleOnClick: false,
  },
  {
    id: 4,
    name: t("ActionBar.Exit"),
    icon: ExitIcon,
    handleOnClick: false,
  },
];

export const success = {
  id: 1,
  title: "Success",
  crossColor: colors.green1,
  icon: <Check />,
};

export const failure = {
  id: 2,
  title: "Danger",
  crossColor: colors.red1,
  icon: <Error />,
};

export const warning = {
  id: 3,
  title: "Warning",
  crossColor: colors.yellow,
  icon: <WarningIcon />,
};

export const globalError: string = "Somthing Went Wrong";

export const mobileAppConfigurationData: ITab[] = [
  {
    id: 0,
    name: t("MobileAppConfiguration.appointment_type"),
    navigate: "appointment",
  },
  {
    id: 1,
    name: t("MobileAppConfiguration.medical_center_news"),
    navigate: "news",
  },
];

// manage user- create user
export const manageCreateUserData: ITab[] = [
  {
    id: 0,
    name: "Primary",
    navigate: "/manageusers/createusers/primary",
  },
  {
    id: 1,
    name: "Secondary",
    navigate: null,
    // navigate: '/manageusers/createusers/secondary',
    activeLocation: "/manageusers/createusers/secondary",
  },
];

// manage user- create user
export const masterTableManagementData: ITab[] = [
  {
    id: 0,
    name: "Manage Category",
    navigate: "/mastertablemanage/managecategory",
  },
  {
    id: 1,
    name: "Manage Category Value",
    navigate: "/mastertablemanage/managecategoryvalue",
  },
];

export const medicalCenterTabData: ITab[] = [
  {
    id: 0,
    name: t("ManageMedicalCenterTab.Branch Setup"),
    navigate: "branch",
  },
  {
    id: 1,
    name: t("ManageMedicalCenterTab.Department Setup"),
    navigate: "department",
  },
  {
    id: 2,
    name: t("ManageMedicalCenterTab.Ward Setup"),
    navigate: "ward",
  },
  {
    id: 3,
    name: t("ManageMedicalCenterTab.Room Setup"),
    navigate: "room",
  },
  {
    id: 4,
    name: t("ManageMedicalCenterTab.Bed Setup"),
    navigate: "bed",
  },
];
//Admin:Manageuser table header data
export const manageuserTableHeaderData: any = [
  {
    Header: "ID",
    accessor: "_id",
  },
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "BRANCH",
    accessor: "branches[0].name",
  },
  {
    Header: "DEPT",
    accessor: "departments[0].name",
  },
  {
    Header: "SPECIALITY",
    accessor: "specialities[0].name",
  },
  {
    Header: "USERGROUP",
    accessor: "user_group_id.name",
  },
  {
    Header: "EMAIL",
    accessor: "email",
  },
  {
    Header: "PHONE NO",
    accessor: "phone",
  },
  {
    Header: "NOTES",
    accessor: "notes",
    Cell: () => {
      return React.createElement(
        Link,
        { to: "/", className: "viewLinkStyle" },
        "View"
      );
    },
  },
  {
    Header: "STATUS",
  },
  {
    Header: "ACTIONS",
  },
];

/* tableHeaderColumns definition for new treatment plans dialog module */
export const newTreatmentPlansTableHeaderData: any = [
  {
    Header: "SERVICES NAME",
    accessor: "label",
  },
  {
    Header: "PRICE",
    accessor: "price",
  },
  {
    Header: "DISCOUNT",
    accessor: "discount",
  },
  {
    Header: "NET PRICE",
    accessor: "netPrice",
  },
  {
    Header: "NOTES",
    accessor: "note",
    Cell: () => {
      return React.createElement(
        Link,
        { to: "/", className: "viewLinkStyle" },
        "View"
      );
    },
  },
  {
    Header: "ACTION",
    accessor: "action",
    Cell: (props: any) => {
      return (
        <>
          <DeleteIcon
            fillColor="#CDD4D8"
            handleClick={() =>
              props.onClick({
                deleteAction: {
                  isDeleteDialogOpen: true,
                  _id: props?.row?.original?.value,
                },
              })
            }
          />
        </>
      );
    },
  },
];
/* tableHeaderColumns definition for new treatment plans dialog module */

export const medicalCenterBranchTableHeader: any = [
  {
    Header: t("BranchSetup.BRANCH NAME"),
    accessor: "name",
  },
  {
    Header: t("BranchSetup.LOCATION"),
    accessor: (row: any) => {
      return <p>{row?.address_id?.city ? row?.address_id?.city : "-"}</p>;
    },
  },
  {
    Header: t("BranchSetup.INITIALS"),
    accessor: "initials",
  },
  {
    Header: t("RcptTableHeader.STATUS"),
  },
  {
    Header: t("DocUploadHeader.ACTION"),
  },
];

export const medicalCenterWardTableHeader: any = [
  {
    Header: t("WardSetup.WARD NO"),
    accessor: "ward_no",
  },
  {
    Header: t("WardSetup.WARD NAME"),
    accessor: "ward_name",
  },
  {
    Header: t("WardSetup.DEPARTMENT NAME"),
    accessor: (row: any) => {
      return <p>{row?.department_id?.name ?? "-"}</p>;
    },
  },
  {
    Header: t("PatientHistoryTableHeader.NOTES"),
    accessor: "",
  },
  {
    Header: t("RcptTableHeader.STATUS"),
  },
  {
    Header: t("DocUploadHeader.ACTION"),
  },
];

export const medicalCenterRoomTableHeader: any = [
  {
    Header: t("RoomSetup.ROOM_NO"),
    accessor: "room_no",
  },
  {
    Header: t("RoomSetup.ROOM_NAME"),
    accessor: "room_name",
  },
  {
    Header: t("RoomSetup.ROOM_TYPE"),
    accessor: "type",
  },
  {
    Header: t("WardSetup.WARD NAME"),
    accessor: (row: any) => {
      return <p>{row?.ward_id?.ward_name ?? "-"}</p>;
    },
  },
  {
    Header: t("PatientHistoryTableHeader.NOTES"),
    accessor: "",
  },
  {
    Header: t("RcptTableHeader.STATUS"),
  },
  {
    Header: t("DocUploadHeader.ACTION"),
  },
];

export const medicalCenterBedTableHeader: any = [
  {
    Header: t("BedSetup.BED_NO"),
    accessor: "bed_no",
  },
  {
    Header: t("BedSetup.BED_NAME"),
    accessor: "bed_name",
  },
  {
    Header: t("RoomSetup.ROOM_NAME"),
    accessor: (row: any) => {
      return <p>{row?.room_id?.room_name ?? "-"}</p>;
    },
  },
  {
    Header: t("BedSetup.COST_PRICE"),
    accessor: "cost_price",
  },
  {
    Header: t("BedSetup.SELL_PRICE"),
    accessor: "sell_price",
  },
  {
    Header: t("PatientHistoryTableHeader.NOTES"),
    accessor: "",
  },
  {
    Header: t("RcptTableHeader.STATUS"),
  },
  {
    Header: t("DocUploadHeader.ACTION"),
  },
];

export const medicalCenterDepartmentTableHeader: any = [
  {
    Header: t("DepartmentSetup.DEPT NAME"),
    accessor: "name",
  },
  {
    Header: t("DepartmentSetup.SPECIALTIES"),
    accessor: "",
  },
  {
    Header: t("PatientHistoryTableHeader.NOTES"),
    accessor: "",
  },
  {
    Header: t("RcptTableHeader.STATUS"),
  },
  {
    Header: t("DocUploadHeader.ACTION"),
  },
];

// range data
export const rangeData = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
  "All",
];

export const rangeWeekData: IRangeData[] = [
  {
    id: 8,
    title: t("Days.All_Days"),
    status: false,
  },
  {
    id: 1,
    title: t("Days.Mon"),
    status: false,
  },
  {
    id: 2,
    title: t("Days.Tue"),
    status: false,
  },
  {
    id: 3,
    title: t("Days.Wed"),
    status: false,
  },
  {
    id: 4,
    title: t("Days.Thu"),
    status: false,
  },
  {
    id: 5,
    title: t("Days.Fri"),
    status: false,
  },
  {
    id: 6,
    title: t("Days.Sat"),
    status: false,
  },
  {
    id: 7,
    title: t("Days.Sun"),
    status: false,
  },
];

export const rangeData2: IRangeData[] = [
  {
    id: 7,
    title: t("Days.All_Days"),
    status: false,
  },
  {
    id: 1,
    title: t("Days.Mon"),
    status: false,
  },
  {
    id: 2,
    title: t("Days.Tue"),
    status: false,
  },
  {
    id: 3,
    title: t("Days.Wed"),
    status: false,
  },
  {
    id: 4,
    title: t("Days.Thu"),
    status: false,
  },
  {
    id: 5,
    title: t("Days.Fri"),
    status: false,
  },
  {
    id: 6,
    title: t("Days.Sat"),
    status: false,
  },
  {
    id: 0,
    title: t("Days.Sun"),
    status: false,
  },
];

// Mobile Config Medical Center News Array
export const medicalNewsArray: { id: number; name: string }[] = [
  { id: 0, name: t("MobileAppConfiguration.News 1") },
  { id: 1, name: t("MobileAppConfiguration.News 2") },
  { id: 2, name: t("MobileAppConfiguration.News 3") },
  { id: 3, name: t("MobileAppConfiguration.News 4") },
  { id: 4, name: t("MobileAppConfiguration.News 5") },
];

export const manageSpecialitiesTableHeaderData: any = [
  {
    Header: t("DepartmentSetup.DEPT"),
    accessor: (row: any) => {
      return row?.department_id?.name;
    },
  },
  {
    Header: t("DepartmentSetup.SPECIALTIES"),
    accessor: "name",
  },
  {
    Header: t("RcptTableHeader.STATUS"),
  },
  {
    Header: t("DocUploadHeader.ACTION"),
  },
];

export const viewSpecialityTableHeaderData: any = [
  {
    Header: t("DepartmentSetup.DEPT"),
    accessor: (row: any) => {
      return <p>{row?.department_id?.name}</p>;
    },
  },
  {
    Header: t("DepartmentSetup.SPECIALTIES"),
    accessor: "name",
  },
];

export const manageUserGroupTabData: ITab[] = [
  {
    id: 0,
    name: t("ManageUserRoles.Primary"),
    navigate: "primary",
  },
  {
    id: 1,
    name: t("ManageUserRoles.Secondary"),
    // navigate: 'secondary',
    navigate: null,
    activeLocation: "/usergroups/manageusergroups/secondary",
  },
];

export const moduleListData: IModuleList[] = [
  {
    _id: 0,
    module_name: "Patient EMR",
  },
  {
    _id: 1,
    module_name: "Receptionist",
  },
  {
    _id: 2,
    module_name: "Doctor",
  },
  {
    _id: 3,
    module_name: "Insurance Masters",
  },
  {
    _id: 4,
    module_name: "Radiology",
  },
  {
    _id: 5,
    module_name: "Call Center Admin",
  },
  {
    _id: 6,
    module_name: "Call Center Agents",
  },
];

// Mobile config HeaderData
export const mobileConfigTableHeaderData: any = [
  {
    Header: t("AllAttachmentHeader.NAME"),
    accessor: (row: any) => {
      return `${row?.type?.toLowerCase()}_appointment_${row.name}`;
    },
  },
  {
    Header: t("RcptTableHeader.TYPE"),
    accessor: (row: any) => {
      return row?.type?.toLowerCase();
    },
  },
  {
    Header: t("MobileAppConfiguration.TITLE"),
    accessor: "title",
  },
  {
    Header: t("MobileAppConfiguration.DESCRIPTION"),
  },
  {
    Header: t("MobileAppConfiguration.PRICE_LISTING"),
    accessor: "price",
  },
  {
    Header: t("ManageCategory.ICON"),
  },
  {
    Header: t("RcptTableHeader.STATUS"),
  },
  {
    Header: t("DocUploadHeader.ACTION"),
  },
];

//Admin:Master table Category Value header data
export const masterTableHeaderData: any = [
  {
    Header: t("ManageCategory.CATEGORY"),
    accessor: "category_name",
  },

  {
    Header: t("ManageCategory.ACTIVE_STATUS"),
  },
  {
    Header: t("DocUploadHeader.ACTION"),
  },
];
//Admin:Master table Category row data
export const masterTableRowData: any = [
  {
    categoryID: "C101",
    categoryName: "B positive",
  },
  {
    categoryID: "C102",
    categoryName: "B positive",
  },
  {
    categoryID: "C103",
    categoryName: "B positive",
  },
];
// Master Import
// export const masterImportTableHeaderData: any = [
//   {
//     Header: (getPropsData) => {
//       const { isSelectAll } = useSelector((state) => state.assignment);
//       const dispatch = useDispatch();
//       const handleSelectAll = (e) => {
//         if (e.target.checked) {
//           handleSelectAllCheckbox();
//         } else {
//           dispatch(removeSelectAll());
//         }

//       };

//       return (
//         <>
//           {
//             <div style={{ marginBottom: "0.938rem" }}>
//               <CustomCheckbox
//                 onChange={(e) => handleSelectAll(e)}
//                 checked={isSelectAll}
//                 customCheckboxStyle={
//                   !getPropsData?.data || getPropsData?.data?.length === 0
//                     ? styles.disabledCheckBoxStyle
//                     : styles.checkBoxStyle
//                 }
//                 disabled={
//                   !getPropsData?.data || getPropsData?.data?.length === 0
//                 }
//               />
//             </div>
//           }
//         </>
//       );
//     },
//     accessor: "check",
//     disableSortBy: true,
//     Cell: (props) => {
//       const { userIdsList } = useSelector((state) => state.assignment);
//       const dispatch = useDispatch();
//       const handleSelectEmployee = (e, value) => {
//         if (e.target.checked) {
//           dispatch(setUserIdList(value));
//         } else {
//           dispatch(removeFromUserIdList(value));
//         }
//       };
//       return (
//         <div style={{ marginBottom: "1.125rem" }}>
//           <CustomCheckbox
//             onChange={(e) =>
//               handleSelectEmployee(e, props?.row?.original?.userId)
//             }
//             checked={userIdsList?.includes(props?.row?.original?.userId)}
//           />
//         </div>
//       );
//     },
//   },
//   // {
//   //   Header: "ALL ",
//   //   Cell: (props: any) => {
//   //     const dispatch = useAppDispatch();
//   //     const handleSelect = (e: any) => {
//   //       if (e?.target?.checked) {
//   //         dispatch(addAllDataBySelectedIDMaster(props?.row?.original));
//   //       } else {
//   //         dispatch(setRemoveArrayMaster(props?.row?.original?._id));
//   //       }
//   //     };
//   //     return (
//   //       <>
//   //         <div>
//   //           <input type="checkbox" onClick={(e) => handleSelect(e)}  className={styles.clicky} />
//   //         </div>
//   //       </>
//   //     );
//   //   },
//   // },
//   {
//     Header: "CODE",
//     accessor: (row: any) => {
//       return row?.code;
//     },
//   },

// ];
//Admin:Master table Category Value header data
export const masterTableCategoryValueHeaderData: any = [
  // {
  //   Header: "ID",
  //   accessor: "_id",
  // },
  {
    Header: "CATEGORY",
    accessor: (row: any) => {
      return row?.category_id?.category_name;
    },
  },
  {
    Header: "VALUE",
    accessor: "value",
  },
  {
    Header: "STATUS",
  },
  {
    Header: "ACTIONS",
  },
];

// AppointType Array

export const appointmentTypeArray = ["AUDIO", "VIDEO", "CHAT", "INPERSON"];

//Admin:Master table Category value row data
export const masterTableCategoryValueRowData: any = [
  {
    categoryID: "C101",
    categoryName: "B positive",
    categoryValue: "A positive",
  },
  {
    categoryID: "C102",
    categoryName: "B positive",
    categoryValue: "A positive",
  },
  {
    categoryID: "C103",
    categoryName: "B positive",
    categoryValue: "A positive",
  },
];

export const assignTagRowData: any = [
  {
    label_name: "VIP",
    label_icon: <VipIcon />,
  },
  {
    label_name: "Diabetes",
    label_icon: <DiabetesIcon />,
  },
  {
    label_name: "Blood Pressure",
    label_icon: <BloodPressureIcon />,
  },
  {
    label_name: "Medical Insurance",
    label_icon: <Error />,
  },
];

// patient EMR: searchModalHeaderData
export const searchModalHeaderData: any = [
  {
    Header: "FILE NO.",
    accessor: "emr_no", //file_no
  },
  {
    Header: "PATIENT NAME",
    accessor: "patient_name",
  },

  {
    Header: "NATIONAL ID",
    accessor: "national_id",
  },
  {
    Header: "MOBILE",
    accessor: "phone",
  },
];
// patient EMR: searchModal row data
export const searchModalRowData: any = [
  {
    file_no: "29-11-2022",
    patient_name: "Andrew Davidson",
    national_id: "987654321",
    mobile: "+971 55 410 2865",
  },
  {
    file_no: "29-11-2022",
    patient_name: "Andrew Davidson",
    national_id: "987654321",
    mobile: "+971 55 410 2865",
  },
  {
    file_no: "29-11-2022",
    patient_name: "Andrew Davidson",
    national_id: "987654321",
    mobile: "+971 55 410 2865",
  },
  {
    file_no: "29-11-2022",
    patient_name: "Andrew Davidson",
    national_id: "987654321",
    mobile: "+971 55 410 2865",
  },
];

export const toDoData1: any = [
  {
    title: "Andrew Davidson",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,  ",
    isDone: false,
  },
  {
    title: "Samantha Davidson",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,  ",
    isDone: false,
  },
  {
    title: "Justin Davidson",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,  ",
    isDone: true,
  },
];

export const appointMenuData: IAppointmenuHeaderMenu[] = [
  {
    id: 0,
    name: "Book Appointment",
    icon: CalanderIcon,
    navigate: "/schedular",
  },
  {
    id: 1,
    name: "View Appointment",
    icon: CalanderIcon,
    navigate: "/viewappointment",
  },
];

export const ReportsMenuData: IAppointmenuHeaderMenu[] = [
  {
    id: 0,
    name: "Laboratory Reports",
    icon: ReportsIcons,
    isActive: true,
  },
  {
    id: 1,
    name: "Radiology Reports",
    icon: ReportsIcons,
    onPopupOpen: "onPopupOpen",
    isActive: true,
  },
  // {
  //   id: 2,
  //   name: "IPD history",
  //   icon: ReportsIcons,
  //   isActive: true,
  // },
  // {
  //   id: 3,
  //   name: "Statement History",
  //   icon: ReportsIcons,
  //   isActive: true,
  // },
];

// Day List

export const daysList: IInterval[] = [
  {
    label: "Monday",
    value: 1,
  },
  {
    label: "Tuesday",
    value: 2,
  },
  {
    label: "Wednesday",
    value: 3,
  },
  {
    label: "Thursday",
    value: 4,
  },
  {
    label: "Friday",
    value: 5,
  },
  {
    label: "Saturday",
    value: 6,
  },
  {
    label: "Sunday",
    value: 0,
  },
];

export const colorSchemeData: IColorCode[] = [
  // {
  //   title: "Available",
  //   label: "AVAILABLE",
  //   colorCode: "#02BF90",
  // },
  {
    title: "Pending",
    label: "PENDING",
    colorCode: "#797979",
    bgColor: "#ffebbe",
  },
  {
    title: "Inprogress",
    label: "INPROGRESS",
    colorCode: "#2d2d2d",
    bgColor: "#d8e6f1",
  },
  {
    title: "Arrived",
    label: "ARRIVED",
    colorCode: "#408D93",
    bgColor: "#d5e2e6",
  },
  {
    title: "No Show",
    label: "NOSHOW",
    colorCode: "#868282",
    bgColor: "#e9e9e9",
  },
  {
    title: "Completed",
    label: "COMPLETED",
    colorCode: "#02BF90",
    bgColor: "#bcfaea",
  },
  {
    title: "Waitinglist",
    label: "WAITINGLIST",
    colorCode: "#80b9ea",
    bgColor: "#d1e9fe",
  },
  {
    title: "Rescheduled",
    label: "RESCHEDULED",
    colorCode: "#ea7101",
    bgColor: "#ffdbba",
  },
  {
    title: "Cancelled",
    label: "CANCELLED",
    colorCode: "#B11313",
    bgColor: "#f7d9d9",
  },
  {
    title: "Scheduled",
    label: "SCHEDULED",
    colorCode: "#5936F1",
    bgColor: "#ded7ff",
  },
  {
    title: "Booked",
    label: "BOOKED",
    colorCode: "#09a122",
    bgColor: "#a1fbb0",
  },
  {
    title: "No Answer",
    label: "NOANSWER",
    colorCode: "#527853",
    bgColor: "#bedcbf",
  },
];

export const moduleScreenData: IModuleScreen[] = [
  {
    id: 0,
    name: "Patient EMR",
    navigate: "/patientemr",
  },
];

export const sessionTimeData: ISesstionTimeData[] = [
  {
    label: "30 min",
    value: 30,
  },
  {
    label: "1 hr",
    value: 60,
  },
  {
    label: "1.5 hrs",
    value: 90,
  },
  {
    label: "2 hrs",
    value: 120,
  },
];
export const intervalData: IInterval[] = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },
  {
    label: "6",
    value: 6,
  },
  {
    label: "7",
    value: 7,
  },
  {
    label: "8",
    value: 8,
  },
  {
    label: "9",
    value: 9,
  },
  {
    label: "10",
    value: 10,
  },
];

export const doctorDiagnosisTabData: ITab[] = [
  {
    id: 0,
    name: "Diagnosis",
    navigate: "diagnosis",
  },
  {
    id: 1,
    name: "Treatment",
    navigate: "treatment",
  },
  {
    id: 2,
    name: "Medication",
    navigate: "medication",
  },
  {
    id: 3,
    name: "Request",
    navigate: "request",
  },
  {
    id: 4,
    name: "Referral",
    navigate: "referral",
  },
  // {
  //   id: 5,
  //   name: 'Invoices',
  //   navigate: 'invoices',
  // },
];

export const notificationDataList: INotiificationData[] = [
  {
    icon: <TodoAlaramIcon fillColor="#FFA873" />,
    title: "Appointment alarm",
    description:
      "Your appointment will be start after 15 minutes. Stay with app and take care.",
    notification_day: "Yesterday  -",
    notification_time: "9:25am",
  },
  {
    icon: <TodoAlaramIcon fillColor="#FFA873" />,
    title: "Appointment alarm",
    description:
      "Your appointment will be start after 15 minutes. Stay with app and take care.",
    notification_day: "Yesterday  -",
    notification_time: "9:25am",
  },
  {
    icon: <TodoAlaramIcon fillColor="#FFA873" />,
    title: "Appointment alarm",
    description:
      "Your appointment will be start after 15 minutes. Stay with app and take care.",
    notification_day: "Yesterday  -",
    notification_time: "9:25am",
  },
  {
    icon: <TodoAlaramIcon fillColor="#FFA873" />,
    title: "Appointment alarm",
    description:
      "Your appointment will be start after 15 minutes. Stay with app and take care.",
    notification_day: "Yesterday  -",
    notification_time: "9:25am",
  },
  {
    icon: <TodoAlaramIcon fillColor="#FFA873" />,
    title: "Appointment alarm",
    description:
      "Your appointment will be start after 15 minutes. Stay with app and take care.",
    notification_day: "Yesterday  -",
    notification_time: "9:25am",
  },
  {
    icon: <TodoAlaramIcon fillColor="#FFA873" />,
    title: "Appointment alarm",
    description:
      "Your appointment will be start after 15 minutes. Stay with app and take care.",
    notification_day: "Yesterday  -",
    notification_time: "9:25am",
  },
];

export const roleData: any = {
  MC_ADMIN: {
    name: "Admin",
  },
  RECEPTIONIST: {
    name: "Receptionist",
  },
  DOCTOR: {
    name: "Doctor",
  },
  LAB_SUPERVISOR: {
    name: "Lab Supervisor",
  },
  RADIOLOGY_SUPERVISOR: {
    name: "Radiology Supervisor",
  },
  PHARMACY_SALESPERSON: {
    name: "Pharmacy Salesperson",
  },
  INVENTORY_MANAGEMENT: {
    name: "inventory management",
  },
  DENTIST: {
    name: "Dentist",
  },
};

export const diagnosisStatusData: IDiagnosisStatusData[] = [
  {
    value: "NS",
    name: "Not started",
  },
  {
    value: "S",
    name: "On going",
  },
  {
    value: "E",
    name: "Completed",
  },
];

export const tagData: ITagData[] = [
  {
    value: "High",
    label: "High Fever",
  },
  {
    value: "Hypertension",
    label: "Hypertension",
  },
  {
    value: "Diabetes",
    label: "Diabetes",
  },
];
export const complianceData: IComplianceData[] = [
  {
    value: "MALAFFI",
    label: "Malaffi",
  },
];
export const dbData: ITDBData[] = [
  {
    value: "MASTER",
    label: "Master",
  },
  {
    value: "LOCAL",
    label: "Local",
  },
];
export const taggedDataList = [
  {
    PATIENT_FILE_NO: "123",
    PATIENT_NAME: "Arwa Guriwala",
    LAST_APPOINTMENT: "08 Jun 2023",
  },
  {
    PATIENT_FILE_NO: "456",
    PATIENT_NAME: "Twinkle Parmar",
    LAST_APPOINTMENT: "09 Jun 2023",
  },
  {
    PATIENT_FILE_NO: "789",
    PATIENT_NAME: "Harsh Solanki",
    LAST_APPOINTMENT: "10 Jun 2023",
  },
];

export const formListData = [
  "Form 1",
  "Form 2",
  "Form 3",
  "Form 4",
  "Form 5",
  "Form 6",
  "Form 7",
  "Form 8",
  "Form 9",
];

export const labJobTabData: ITab[] = [
  {
    id: 0,
    name: t("LabJob.Create_Jobs"),
    navigate: "createjobs",
  },
  {
    id: 1,
    name: t("Header Title.View Jobs"),
    navigate: "viewJobs",
  },
];

export const RadiologyJobTabData: IRadiologyTab[] = [
  {
    id: 0,
    name: t("LabJob.Create_Jobs"),
    navigate: "createjobs",
  },
  {
    id: 1,
    name: t("Header Title.View Jobs"),
    navigate: "viewJobs",
  },
];

export const pharmacyJobData: ITab[] = [
  {
    id: 0,
    name: t("POS.Information"),
    navigate: "pharmacy-info",
  },
  {
    id: 1,
    name: t("InvoicePayment.Payment"),
    navigate: "pharmacy-payment",
  },
  {
    id: 2,
    name: t("POS.On_Hold"),
    navigate: "pharmacy-onhold",
  },
];

export const referalTypeData = [
  { name: "Doctor", _id: "0" },
  { name: "Medical Center", _id: "1" },
];
export const claimTypeDropdown = [
  {
    value: "medical",
    label: "Medical",
  },
  {
    value: "surgical",
    label: "Surgical",
  },
];

export const reimbursementTypeDropdown = [
  {
    value: "Medical",
    label: "medical",
  },
  {
    value: "Patient",
    label: "patient",
  },
];

export const coPayDropdown = [
  {
    value: "Yes",
    label: true,
  },
  {
    value: "No",
    label: false,
  },
];
export const isCancelAppointmentShowDropdown = [
  {
    value: "Yes",
    label: true,
  },
  {
    value: "No",
    label: false,
  },
];

export const invoiceTabData: ITab[] = [
  {
    id: 0,
    name: "Information",
    navigate: null,
    activeLocation: "/invoice/information",
  },
  {
    id: 1,
    name: "Services",
    navigate: null,
    activeLocation: "/invoice/services",
  },
  {
    id: 2,
    name: "Payment",
    navigate: null,
    activeLocation: "/invoice/payment",
  },
];

export const configuratons: ITab[] = [
  // {
  //   id: 0,
  //   name: "Upay",
  //   navigate: "/configuration/upay",
  //   activeLocation: "/configuration/upay",
  // },
  {
    id: 0,
    name: "WhatsApp",
    navigate: "/configuration/whatsup",
    activeLocation: "/configuration/whatsup",
  },
  // {
  //   id: 0,
  //   name: "Waapi Template",
  //   navigate: "/configuration/wapi",
  //   activeLocation: "/configuration/wapi",
  // },

  {
    id: 0,
    name: "configuration",
    navigate: "/configuration/configuration-details",
    activeLocation: "/configuration/configuration-details",
  },
  {
    id: 0,
    name: "Tax",
    navigate: "/configuration/tax",
    activeLocation: "/configuration/tax",
  },
  // {
  //   id: 0,
  //   name: "Compliance",
  //   navigate: "/configuration/compliance",
  //   activeLocation: "/configuration/compliance",
  // },
];

// Lab Invoice Tab Data
export const labInvoiceTabData: ITab[] = [
  {
    id: 0,
    name: t("LabInvoice.Lab_Information"),
    navigate: null,
    activeLocation: "/invoice/labinformation",
  },
  {
    id: 1,
    name: t("Header Title.Lab Services"),
    navigate: null,
    activeLocation: "/invoice/labservices",
  },
  {
    id: 2,
    name: t("InvoicePayment.Payment"),
    navigate: null,
    activeLocation: "/invoice/labpayment",
  },
];

// radiology invoice module
export const radiologyTabData: ITab[] = [
  {
    id: 0,
    name: t("RadiologyInvoice.Radiology_Information"),
    navigate: null,
    activeLocation: "/radiology-invoice/information",
  },
  {
    id: 1,
    name: t("RadiologyInvoice.Radiology_Services"),
    navigate: null,
    activeLocation: "/radiology-invoice/services",
  },
  {
    id: 2,
    name: t("InvoicePayment.Payment"),
    navigate: null,
    activeLocation: "/radiology-invoice/payment",
  },
];

// Lab Request Floating Bar Data
export const labRequestFloatingBarData: IFormActionSidebar[] = [
  {
    id: 0,
    name: "Add",
    icon: AddIcon,
  },
  {
    id: 1,
    name: "Save",
    icon: SaveIcon,
  },
  {
    id: 2,
    name: "Delete",
    icon: DeleteIcon,
  },
  {
    id: 3,
    name: "Print",
    icon: PrintFormIcon,
  },
  {
    id: 4,
    name: "Exit",
    icon: ExitIcon,
  },
];

// Receipt Floating Bar Data
export const receiptFloatingBarData: IFormActionSidebar[] = [
  {
    id: 0,
    name: "Add",
    icon: AddIcon,
  },
  {
    id: 1,
    name: "Save",
    icon: SaveIcon,
  },
  {
    id: 2,
    name: "Print",
    icon: PrintFormIcon,
  },
  {
    id: 3,
    name: "Exit",
    icon: ExitIcon,
  },
];
// Campaigns Floating Bar Data
export const campaignsFloatingBarData: IFormActionSidebar[] = [
  {
    id: 0,
    name: "Add",
    icon: AddIcon,
  },
  {
    id: 1,
    name: "Save",
    icon: SaveIcon,
  },
  {
    id: 2,
    name: "Delete",
    icon: DeleteIcon,
  },
  {
    id: 3,
    name: "Print",
    icon: PrintFormIcon,
  },
  {
    id: 4,
    name: "Exit",
    icon: ExitIcon,
  },
];

export const CampaignsTabData = [
  {
    id: 0,
    name: t("Sidebar.Campaigns"),
    navigate: "onGoingCampaigns",
  },
  {
    id: 1,
    name: t("Campaigns.Create_Campaign"),
    navigate: "createCampaigns",
  },
];

export const onGoingClaimsTypesData: any = {
  INITIATED: { value: "INITIATED", status: "Initiated" },
  SETTLED: { value: "SETTLED", status: "Settled" },
  REJECTED: { value: "REJECTED", status: "Rejected" },
};

export const sourceData = [
  {
    value: "internal",
    label: "Internal",
  },
  {
    value: "external",
    label: "External",
  },
];

export const genderData: any = [
  // {
  //   value: 'ALL',
  //   label: 'All',
  // },
  {
    value: "MALE",
    label: "Male",
  },
  {
    value: "FEMALE",
    label: "Female",
  },
];

// master value data
export const masterTableNewHeaderData: any = [
  {
    Header: t("ManageCategory.STATUS_NAME"),
    accessor: "value",
  },

  {
    Header: t("ManageCategory.COLOR"),
    Cell: (cell: any) => {
      const color = cell?.row?.original?.metadata?.color_code;
      return (
        <>
          <div
            style={{
              backgroundColor: color,
              display: "flex",
              alignItems: "center",
              borderRadius: "50%",
              height: "30px",
              width: "30px",
            }}
            className={styles.iconImg}
          ></div>
        </>
      );
    },
    accessor: "color_code",
  },
  {
    Header: t("ManageCategory.BG_COLOR"),
    Cell: (cell: any) => {
      const color = cell?.row?.original?.metadata?.bg_color;
      return (
        <>
          <div
            style={{
              backgroundColor: color,
              display: "flex",
              alignItems: "center",
              borderRadius: "50%",
              height: "30px",
              width: "30px",
            }}
            className={styles.iconImg}
          ></div>
        </>
      );
    },
    accessor: "bg_color",
  },
  {
    Header: t("ManageCategory.ACTIVE_STATUS"),

    Cell: (props: any) => {
      const is_active = props?.row?.original?.is_active;
      return (
        <ToggleSwitchV2
          isToggled={is_active}
          handleToggle={() => props.onClick(props?.row?.original)}
        />
      );
    },
  },
  {
    Header: t("DocUploadHeader.ACTION"),

    Cell: ({ row }: any) => {
      const dispatch = useAppDispatch();
      const handleEdit = (item: any) => {
        dispatch(getAllMasterValuePayloadData(item));
      };
      return (
        <EditIcon
          fillColor={colors.grey4}
          handleClick={() =>
            row?.original?.is_active && handleEdit(row?.original)
          }
        />
      );
    },
  },
];

// asign tag table
export const assignTagData: any = [
  {
    Header: t("ManageCategory.STATUS_NAME"),
    accessor: "value",
  },

  {
    Header: t("ManageCategory.ICON"),

    Cell: (cell: any) => {
      const color = cell?.row?.original?.metadata?.icon;
      return (
        <>
          <img className={styles.iconImg} src={color} alt="" />
        </>
      );
    },
    accessor: "icon",
  },
  {
    Header: t("ManageCategory.ACTIVE_STATUS"),
    Cell: (props: any) => {
      const is_active = props?.row?.original?.is_active;
      return (
        <ToggleSwitchV2
          isToggled={is_active}
          handleToggle={() => props.onClick(props?.row?.original)}
        />
      );
    },
  },
  {
    Header: t("DocUploadHeader.ACTION"),
    Cell: ({ row }: any) => {
      const dispatch = useAppDispatch();
      const handleEdit = (item: any) => {
        dispatch(getAllMasterValuePayloadData(item));
      };
      return (
        <EditIcon
          fillColor={colors.grey4}
          handleClick={() =>
            row?.original?.is_active && handleEdit(row?.original)
          }
        />
      );
    },
  },
];

// paymentmode table header
export const paymentModeTableData: any = [
  // {
  //   Header: "ID",
  //   accessor: "_id",
  // },
  {
    Header: "NAME",
    accessor: "value",
  },

  {
    Header: "ICON",
    Cell: (cell: any) => {
      const color = cell?.row?.original?.metadata?.icon;
      return (
        <>
          <img className={styles.iconImg} src={color} alt="" />
        </>
      );
    },
    accessor: "icon",
  },
  {
    Header: "ACTIVE STATUS",
    Cell: (props: any) => {
      const is_active = props?.row?.original?.is_active;
      return (
        <ToggleSwitchV2
          isToggled={is_active}
          handleToggle={() => props.onClick(props?.row?.original)}
        />
      );
    },
  },
  {
    Header: "ACTION",
    Cell: ({ row }: any) => {
      const dispatch = useAppDispatch();
      const handleEdit = (item: any) => {
        dispatch(getAllMasterValuePayloadData(item));
      };
      return (
        <EditIcon
          fillColor={colors.grey4}
          handleClick={() =>
            row?.original?.is_active && handleEdit(row?.original)
          }
        />
      );
    },
  },
];

export const masterValuesHeader = [
  {
    Header: t("ManageCategory.VALUE"),
    accessor: "value",
  },
  {
    Header: t("RcptTableHeader.DATE"),
    Cell: (props: any) => {
      const date = props?.row?.original?.metadata?.[HOLIDAY_DATE];
      return <span>{date ? moment(date).format("DD-MM-YYYY") : "-"}</span>;
    },
  },
  {
    Header: t("ManageCategory.COUNTRY_CODE"),
    Cell: (props: any) => {
      const countryCode = props?.row?.original?.metadata?.country_code;
      return <span>{countryCode ? countryCode : "-"}</span>;
    },
  },
  {
    Header: t("ManageCategory.ACCOUNT_NO"),
    Cell: (props: any) => {
      const acc = props?.row?.original?.metadata?.[ACCOUNT_NO];
      return <span>{acc ? acc : "-"}</span>;
    },
  },
  {
    Header: t("CallCenterAdmin.CODE"),
    Cell: (props: any) => {
      const code = props?.row?.original?.metadata?.[COMPLAINT_CODE];
      return <span>{code ? code : "-"}</span>;
    },
  },

  {
    Header: t("ManageCategory.ACTIVE_STATUS"),
    Cell: (props: any) => {
      const is_active = props?.row?.original?.is_active;
      return (
        <ToggleSwitchV2
          isToggled={is_active}
          handleToggle={() => props.onClick(props?.row?.original)}
        />
      );
    },
  },
  {
    Header: t("DocUploadHeader.ACTION"),
    Cell: ({ row }: any) => {
      const dispatch = useAppDispatch();
      const handleEdit = (item: any) => {
        dispatch(getAllMasterValuePayloadData(item));
      };
      return (
        <EditIcon
          fillColor={colors.grey4}
          handleClick={() =>
            row?.original?.is_active && handleEdit(row?.original)
          }
        />
      );
    },
  },
];

export const paymentModeModalData = [
  {
    payment_mode_id: 0,
    payment_mode_name: "cash",
    payment_mode_label: "Cash",
    payment_mode_img: paymentCash,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 1,
    payment_mode_name: "knet",
    payment_mode_label: "KNET",
    payment_mode_img: paymentKnet,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 2,
    payment_mode_name: "debit",
    payment_mode_label: "Debit",
    payment_mode_img: paymentDebit,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 3,
    payment_mode_name: "credit",
    payment_mode_label: "Credit",
    payment_mode_img: paymentCredit,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 4,
    payment_mode_name: "pay_with_advance",
    payment_mode_label: "Pay with Advance",
    payment_mode_img: paymentCash,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 5,
    payment_mode_name: "loyalty_points",
    payment_mode_label: "Loyalty points",
    payment_mode_img: paymentLoyaltyPoints,
    is_payment_disable: false,
  },

  // {
  //   payment_mode_id: 6,
  //   payment_mode_name: 'mode_d',
  // payment_mode_label: "Mode D",
  //   payment_mode_img: paymentCash,
  // is_payment_disable: false,
  // },
];

export const subStoreData = [
  {
    id: 0,
    name: "Issue",
    navigate: "/issue",
  },
  {
    id: 1,
    name: "MS Request",
    navigate: "/msrequest",
  },
];

export const submittedPoPopupHeaderData: any = [
  {
    Header: "DATE",
    accessor: "_date",
  },
  {
    Header: "DOC ID",
    accessor: "doc_id",
  },
  {
    Header: "PO NO",
    accessor: "po_no",
  },
  {
    Header: "SUPPLIER NAME",
    accessor: "_source",
  },
  {
    Header: "STATUS",
    accessor: "_status",
  },

  {
    Header: "AUTHORIZED STATUS",
    accessor: "auth_status",
  },
];

export const submittedPoPopupData = [
  {
    _date: "10 Jan 2023",
    doc_id: "INV_REQ_200|2023|530",
    po_no: "#1234",
    _status: "Initiated",
    _source: "Powell Supplier",
    auth_status: "Entered",
  },
  {
    _date: "10 Jan 2023",
    doc_id: "INV_REQ_200|2023|530",
    po_no: "#4658 ",
    _status: "Initiated",
    _source: "Rose Supplier",
    auth_status: "Entered",
  },
  {
    _date: "10 Jan 2023",
    doc_id: "INV_REQ_200|2023|530",
    po_no: "#5236",
    _status: "Initiated",
    _source: "Powell Supplier",
    auth_status: "Entered",
  },
  {
    _date: "10 Jan 2023",
    doc_id: "INV_REQ_200|2023|530",
    po_no: "#4896",
    _status: "Initiated",
    _source: "Rose Supplier",
    auth_status: "Entered",
  },
];

export const poSummaryPopupHeaderData: any = [
  {
    Header: "DATE",
    accessor: "_date",
  },
  {
    Header: "SUPPLIER NAME",
    accessor: "doc_id",
  },
  {
    Header: "PO NO",
    accessor: "po_no",
  },

  {
    Header: "STATUS",
    accessor: "_status",
  },

  {
    Header: "GRN",
    accessor: "_grn",
  },
  {
    Header: "NOTES",
    accessor: "_notes",
  },
];

export const poSummaryPopupData = [
  {
    _date: "10 Jan 2023",
    doc_id: "INV_REQ_200|2023|530",
    po_no: "#1234",
    _status: "Initiated",
    _source: "Powell Supplier",
    auth_status: "Entered",
  },
  {
    _date: "10 Jan 2023",
    doc_id: "INV_REQ_200|2023|530",
    po_no: "#4658 ",
    _status: "Initiated",
    _source: "Rose Supplier",
    auth_status: "Entered",
  },
  {
    _date: "10 Jan 2023",
    doc_id: "INV_REQ_200|2023|530",
    po_no: "#5236",
    _status: "Initiated",
    _source: "Powell Supplier",
    auth_status: "Entered",
  },
  {
    _date: "10 Jan 2023",
    doc_id: "INV_REQ_200|2023|530",
    po_no: "#4896",
    _status: "Initiated",
    _source: "Rose Supplier",
    auth_status: "Entered",
  },
];

export const vfg: ICurrencyValue[] = [
  {
    id: 0,
    name: "US Dollar (USD)",
    value: "us_dollar",
    icon: UsDollarCurrencyIcon,
  },
  {
    id: 1,
    name: "Kuwait Dinar (KD)",
    value: "kuwait_dinar",
    icon: KuwaitDinarCurrencyIcon,
  },
  {
    id: 2,
    name: "Emirati Dirham(AED)",
    value: "emirati_dirham",
    icon: EmiratiDirhamCurrencyIcon,
  },
];

export const poFormCurrencyData: any = [
  {
    value: 1,
    text: "US Dollar (USD)",
    icon: (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.49833 0C3.35231 0 0 3.35231 0 7.49833C0 11.6443 3.35231 15 7.49833 15C11.6443 15 15 11.6443 15 7.49833C15 3.35231 11.6443 0 7.49833 0ZM1.41996 4.17281C2.05626 3.01072 3.01741 2.04956 4.1795 1.41326C4.33691 1.34293 4.44407 1.42666 4.48091 1.50368C4.53784 1.61085 4.49766 1.74481 4.39049 1.80174C3.30208 2.39451 2.40455 3.29873 1.80844 4.38714C1.75151 4.49766 1.6142 4.53784 1.50368 4.47756C1.39652 4.41728 1.35968 4.27997 1.41996 4.17281ZM1.58741 7.44809C1.58741 4.17281 4.24983 1.50703 7.52847 1.50703C10.8071 1.50703 13.4662 4.16946 13.4662 7.44809C13.4662 10.7267 10.8038 13.3891 7.52847 13.3891C4.25318 13.3891 1.58741 10.7267 1.58741 7.44809ZM10.8439 13.5733C10.7368 13.6303 10.6028 13.5934 10.5459 13.4863C10.4856 13.3791 10.5258 13.2418 10.633 13.1849C11.7214 12.5854 12.6155 11.6845 13.2083 10.5928C13.2485 10.5224 13.3054 10.4923 13.3657 10.4823C13.4226 10.4722 13.4762 10.4856 13.5097 10.5023C13.6169 10.5593 13.6571 10.6932 13.6001 10.8004C12.9638 11.9658 12.006 12.9337 10.8439 13.5733Z"
          fill="#FFA009"
        />
        <path
          d="M7.50092 2.06641C4.52369 2.06641 2.11914 4.47096 2.11914 7.44819C2.11914 10.4254 4.52369 12.83 7.50092 12.83C10.4781 12.83 12.8827 10.4254 12.8827 7.44819C12.8827 4.47096 10.4748 2.06641 7.50092 2.06641ZM9.09168 9.77237C8.85055 10.0671 8.53575 10.2647 8.16737 10.3651C8.00662 10.4087 7.93294 10.4924 7.94299 10.6598C7.94968 10.8239 7.94299 10.9847 7.93964 11.1521C7.93964 11.2995 7.86596 11.3765 7.72195 11.3799C7.62818 11.3832 7.53441 11.3832 7.44064 11.3832C7.35692 11.3832 7.27654 11.3832 7.19282 11.3799C7.03877 11.3765 6.96509 11.2894 6.96509 11.1387C6.96174 11.0215 6.96174 10.8976 6.96174 10.7804C6.95839 10.5158 6.95169 10.5058 6.69717 10.4656C6.37232 10.412 6.05417 10.3417 5.75611 10.1977C5.52169 10.0838 5.49824 10.0269 5.56522 9.77907C5.61546 9.59487 5.66569 9.41403 5.72262 9.23319C5.76281 9.09923 5.803 9.04229 5.87333 9.04229C5.91351 9.04229 5.9671 9.06239 6.03743 9.09923C6.36562 9.27002 6.71392 9.36714 7.0823 9.41068C7.14258 9.41738 7.20621 9.42073 7.26649 9.42073C7.43729 9.42073 7.60474 9.38724 7.76549 9.31691C8.17406 9.13941 8.23769 8.66721 7.89275 8.38255C7.77554 8.28543 7.64158 8.2151 7.50092 8.15482C7.14258 7.99742 6.77085 7.8802 6.4326 7.67592C5.88337 7.34772 5.53843 6.89896 5.57862 6.22917C5.6255 5.47565 6.05082 5.00679 6.74406 4.75562C7.02872 4.6518 7.03207 4.65515 7.03207 4.3571C7.03207 4.25663 7.02872 4.15616 7.03542 4.05234C7.04211 3.82796 7.07895 3.79112 7.30333 3.78442C7.32678 3.78442 7.35692 3.78442 7.38036 3.78442C7.4239 3.78442 7.46743 3.78442 7.51097 3.78442C7.52771 3.78442 7.54781 3.78442 7.56455 3.78442C7.98987 3.78442 7.98987 3.80117 7.98987 4.25998C7.99322 4.59822 7.99322 4.59822 8.32812 4.6518C8.58599 4.69199 8.83046 4.76902 9.06824 4.87284C9.19885 4.92977 9.24908 5.02019 9.20889 5.16085C9.14861 5.36513 9.09168 5.57277 9.02805 5.77706C8.98786 5.90097 8.94767 5.9579 8.874 5.9579C8.83381 5.9579 8.78357 5.94116 8.71994 5.91101C8.39175 5.75026 8.0468 5.67324 7.68512 5.67324C7.63823 5.67324 7.59134 5.67659 7.54446 5.67659C7.43729 5.68329 7.33347 5.69668 7.23301 5.74022C6.87802 5.89427 6.82108 6.28945 7.12249 6.53057C7.27654 6.65448 7.45069 6.74156 7.63153 6.81523C7.94633 6.94584 8.26114 7.06976 8.55919 7.23385C9.5036 7.76634 9.75812 8.96192 9.09168 9.77237Z"
          fill="#FFA009"
        />
      </svg>
    ),
  },
  {
    value: 2,
    // text: "Kuwait Dinar (KD)",
    text: "INR",
    icon: (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_18095_15604)">
          <path
            d="M7.5274 2.06836C4.55119 2.06836 2.14453 4.47502 2.14453 7.45123C2.14453 10.4274 4.55119 12.8341 7.5274 12.8341C10.5036 12.8341 12.9068 10.4274 12.9068 7.45123C12.9068 4.47502 10.5036 2.06836 7.5274 2.06836ZM3.65173 5.1418H4.47132V7.35399L4.92626 6.79139L6.30497 5.13833H7.29472L5.54442 7.22897L7.39543 9.85789H6.42304L5.00266 7.81935L4.46785 8.38542V9.85789H3.64826L3.65173 5.1418ZM7.83301 5.1418H9.22561C9.64235 5.1418 10.0105 5.23557 10.3334 5.41963C10.6564 5.60369 10.9065 5.86762 11.0836 6.21143C11.2919 6.68373 11.3475 7.11436 11.351 7.6214C11.351 8.06939 11.2607 8.46182 11.0801 8.80215C10.903 9.14249 10.6495 9.40295 10.3195 9.58701C9.98963 9.77107 9.61456 9.86136 9.18741 9.86136H7.82954V5.1418H7.83301ZM8.65259 5.80164V9.20153H9.18741C9.61804 9.20153 9.94795 9.06609 10.1772 8.79868C10.4098 8.5278 10.5244 8.14232 10.5314 7.63876C10.5835 7.11089 10.4411 6.51357 10.198 6.20449C9.97574 5.93361 9.65276 5.79817 9.22908 5.79817H8.65259V5.80164Z"
            fill="#FFA009"
          />
          <path
            d="M7.49977 0.00195312C3.35322 0.00195312 0.00195312 3.35322 0.00195312 7.49977C0.00195312 11.6463 3.35322 15.0011 7.49977 15.0011C11.6463 15.0011 15.0011 11.6463 15.0011 7.49977C15.0011 3.35322 11.6428 0.00195312 7.49977 0.00195312ZM4.48189 1.50221C4.53745 1.60987 4.49925 1.74183 4.3916 1.80087C3.30113 2.39472 2.40514 3.29766 1.80782 4.38465C1.74878 4.49578 1.61334 4.53398 1.50568 4.47494C1.39803 4.4159 1.35983 4.27699 1.41886 4.16933C2.05786 3.00594 3.01636 2.04397 4.17975 1.40844C4.33603 1.33899 4.44369 1.42234 4.48189 1.50221ZM7.52755 1.50916C10.8024 1.50916 13.4661 4.17281 13.4661 7.44768C13.4661 10.7225 10.8024 13.3862 7.52755 13.3862C4.25268 13.3862 1.58903 10.7225 1.58903 7.44768C1.58903 4.17281 4.25268 1.50916 7.52755 1.50916ZM13.5077 10.5003C13.6154 10.5593 13.6536 10.6913 13.598 10.7989C12.966 11.9658 12.0075 12.9313 10.8476 13.5703C10.7399 13.6293 10.6079 13.5876 10.5489 13.4834C10.4899 13.3758 10.5281 13.2403 10.6357 13.1813C11.7227 12.5805 12.6187 11.681 13.2126 10.5871C13.2508 10.5176 13.3098 10.4864 13.3688 10.476C13.4209 10.469 13.473 10.4829 13.5077 10.5003Z"
            fill="#FFA009"
          />
        </g>
        <defs>
          <clipPath id="clip0_18095_15604">
            <rect width="15" height="15" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
  {
    value: 3,
    text: "Emirati Dirham(AED)",
    icon: (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_18095_15617)">
          <path
            d="M7.52749 2.06836C4.55123 2.06836 2.14453 4.47506 2.14453 7.45131C2.14453 10.4276 4.55123 12.8343 7.52749 12.8343C10.5037 12.8343 12.907 10.4276 12.907 7.45131C12.907 4.47506 10.5037 2.06836 7.52749 2.06836ZM4.78739 4.0479C5.0166 5.38148 5.22497 6.56573 5.26317 7.82291C5.26317 8.06601 5.23539 8.28828 5.17635 8.4897C5.12078 8.68766 5.00618 8.95854 4.84295 9.29541L4.59638 9.19817C4.66236 8.85088 4.69362 8.56611 4.69362 8.34731C4.68667 7.34713 4.23867 5.61764 4.30119 5.21826C4.38106 4.79456 4.61374 4.39866 4.78739 4.0479ZM9.90988 5.1488C10.6947 5.8017 10.8684 6.74285 10.8684 7.70136V9.01411H9.01735C8.58671 9.01758 8.42001 8.73628 8.43043 8.44455C8.42349 8.16325 8.46863 7.89237 8.50336 7.63538L8.65964 7.62843C8.71868 7.87848 8.91664 7.89931 9.07639 7.90279H10.4829C10.3996 7.22558 10.1877 6.74979 9.62163 6.42682L9.90988 5.1488ZM6.74956 8.99674C7.11769 8.99674 7.41983 9.27804 7.41983 9.6288C7.41983 9.97609 7.12116 10.2574 6.75304 10.2574C6.38491 10.2574 6.08624 9.97609 6.08624 9.6288C6.0793 9.27804 6.37796 8.99674 6.74956 8.99674ZM4.90199 9.76772C5.09995 9.7573 5.11384 9.96567 5.06869 10.0664C5.05827 10.0976 5.03396 10.1428 4.99576 10.2053C4.86032 10.1358 4.76655 10.1046 4.71793 10.1046C4.61374 10.0872 4.52692 10.1497 4.48178 10.2053C4.56512 10.3546 4.79086 10.4623 4.96103 10.4797C5.08258 10.4658 5.16246 10.438 5.25623 10.4171C5.24581 10.5873 5.12078 10.6498 5.02007 10.6846L4.13796 10.9554C4.19005 10.7783 4.34286 10.7158 4.49219 10.6394C4.34286 10.5977 4.28729 10.4727 4.27688 10.3789C4.28382 10.0699 4.6068 9.78161 4.90199 9.76772Z"
            fill="#FFA009"
          />
          <path
            d="M7.49989 0.00195312C3.35328 0.00195312 0.00195312 3.35328 0.00195312 7.49989C0.00195312 11.6465 3.35328 15.0013 7.49989 15.0013C11.6465 15.0013 15.0013 11.6465 15.0013 7.49989C15.0013 3.35328 11.643 0.00195312 7.49989 0.00195312ZM4.48196 1.50223C4.53753 1.60989 4.49932 1.74186 4.39167 1.8009C3.30118 2.39476 2.40518 3.29771 1.80785 4.38472C1.74881 4.49585 1.61337 4.53405 1.50571 4.47501C1.39805 4.41598 1.35985 4.27706 1.41889 4.1694C2.05789 3.00599 3.01641 2.044 4.17982 1.40847C4.3361 1.33901 4.44376 1.42236 4.48196 1.50223ZM7.52767 1.50918C10.8026 1.50918 13.4663 4.17287 13.4663 7.44779C13.4663 10.7227 10.8026 13.3864 7.52767 13.3864C4.25275 13.3864 1.58906 10.7227 1.58906 7.44779C1.58906 4.17287 4.25275 1.50918 7.52767 1.50918ZM13.508 10.5004C13.6156 10.5595 13.6538 10.6915 13.5983 10.7991C12.9662 11.966 12.0077 12.9315 10.8477 13.5705C10.7401 13.6295 10.6081 13.5878 10.5491 13.4836C10.49 13.376 10.5282 13.2405 10.6359 13.1815C11.7229 12.5807 12.6189 11.6812 13.2128 10.5873C13.251 10.5178 13.31 10.4866 13.369 10.4761C13.4211 10.4692 13.4732 10.4831 13.508 10.5004Z"
            fill="#FFA009"
          />
        </g>
        <defs>
          <clipPath id="clip0_18095_15617">
            <rect width="15" height="15" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
  },
];
export const receiptOutstandingPaymentModeData = [
  {
    payment_mode_id: 0,
    payment_mode_name: "cash",
    payment_mode_label: "Cash",
    payment_mode_img: paymentCash,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 1,
    payment_mode_name: "knet",
    payment_mode_label: "KNET",
    payment_mode_img: paymentKnet,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 2,
    payment_mode_name: "debit",
    payment_mode_label: "Debit",
    payment_mode_img: paymentDebit,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 3,
    payment_mode_name: "credit",
    payment_mode_label: "Credit",
    payment_mode_img: paymentCredit,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 4,
    payment_mode_name: "pay_with_advance",
    payment_mode_label: "Pay with Advance",
    payment_mode_img: paymentCash,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 5,
    payment_mode_name: "loyalty_points",
    payment_mode_label: "Loyalty points",
    payment_mode_img: paymentLoyaltyPoints,
    is_payment_disable: false,
  },
];

export const receiptAdvancePaymentModeData = [
  {
    payment_mode_id: 0,
    payment_mode_name: "cash",
    payment_mode_label: "Cash",
    payment_mode_img: paymentCash,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 1,
    payment_mode_name: "knet",
    payment_mode_label: "KNET",
    payment_mode_img: paymentKnet,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 2,
    payment_mode_name: "debit",
    payment_mode_label: "Debit",
    payment_mode_img: paymentDebit,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 3,
    payment_mode_name: "credit",
    payment_mode_label: "Credit",
    payment_mode_img: paymentCredit,
    is_payment_disable: false,
  },
  {
    payment_mode_id: 4,
    payment_mode_name: "pay_with_advance",
    payment_mode_label: "Pay with Advance",
    payment_mode_img: paymentCash,
    is_payment_disable: true,
  },
  {
    payment_mode_id: 5,
    payment_mode_name: "loyalty_points",
    payment_mode_label: "Loyalty points",
    payment_mode_img: paymentLoyaltyPoints,
    is_payment_disable: false,
  },
];
export const relationData: any = [
  { code: "ASC", name: "Associate" },
  { code: "BRO", name: "Brother" },
  { code: "CGV", name: "Care giver" },
  { code: "CHD", name: "Child" },
  { code: "DEP", name: "Handicapped dependent" },
  { code: "DOM", name: "Life partner" },
  { code: "EMC", name: "Emergency contact" },
  { code: "EME", name: "Employee" },
  { code: "EMR", name: "Employer" },
  { code: "EXF", name: "Extended family" },
  { code: "FCH", name: "Foster child" },
  { code: "FND", name: "Friend" },
  { code: "FTH", name: "Father" },
  { code: "GCH", name: "Grandchild" },
  { code: "GRD", name: "Guardian" },
  { code: "GRP", name: "Grandparent" },
  { code: "MGR", name: "Manager" },
  { code: "MTH", name: "Mother" },
  { code: "NCH", name: "Natural child" },
  { code: "NON", name: "None" },
  { code: "OAD", name: "Other adult" },
  { code: "OTH", name: "Other" },
  { code: "OWN", name: "Owner" },
  { code: "PAR", name: "Parent" },
  { code: "SCH", name: "Stepchild" },
  { code: "SEL", name: "Self" },
  { code: "SIB", name: "Sibling" },
  { code: "SIS", name: "Sister" },
  { code: "SPO", name: "Spouse" },
  { code: "TRA", name: "Trainer" },
  { code: "UNK", name: "Unknown" },
  { code: "WRD", name: "Ward of court" },
];
export const allergiesData: any = [
  { code: "AA", name: "Animal Allergy" },
  { code: "DA", name: "Drug allergy" },
  { code: "EA", name: "Environmental Allergy" },
  { code: "FA", name: "Food allergy" },
  { code: "LA", name: "Pollen Allergy" },
  { code: "MA", name: "Miscellaneous allergy" },
  { code: "MC", name: "Miscellaneous contraindication" },
  { code: "PA", name: "Plant Allergy" },
];

export const sourceDestinationdata: any = [
  {
    value: "DEPARTMENT",
    lable: "Department",
  },
  {
    value: "ROOM",
    lable: "Room",
  },
  {
    value: "INDIVIDUAL",
    lable: "Individual",
  },
  {
    value: "BRANCH_STORE",
    lable: "Branch Store",
  },
];

export const sourcePharmacyDestinationdata: any = [
  {
    value: "DEPARTMENT",
    lable: "Department",
  },
  {
    value: "ROOM",
    lable: "Room",
  },
  {
    value: "INDIVIDUAL",
    lable: "Individual",
  },
];
export const appointmentTypes = ["CHAT", "AUDIO", "VIDEO"];

// Dentist Sidebar Data
export const dentistSidebarData: ISidebar[] = [
  {
    id: 0,
    name: "Dentist",
    icon: DashboardIcon,
    navigate: "/dentist",
  },
  {
    id: 1,
    name: "Diagnosis",
    icon: DiagnosisIcon,
    navigate: "/patientdiagnosis",
    activeLocation: "patientdiagnosis",
  },
  {
    id: 2,
    name: "Form Builder",
    icon: FormBuilderIcon,
    navigate: "/formBuilder",
  },
  {
    id: 4,
    name: "Patient EMR",
    icon: PatientEMRIcon,
    navigate: "/patientemr",
    activeLocation: "patientemr",
  },
];

export const dentistDiagnosisTabData: ITab[] = [
  {
    id: 0,
    name: "Diagnosis",
    navigate: "diagnosis",
  },
  {
    id: 1,
    name: "Treatment",
    navigate: "treatment",
  },
  {
    id: 2,
    name: "Medication",
    navigate: "medication",
  },
  {
    id: 3,
    name: "Request",
    navigate: "request",
  },
  {
    id: 4,
    name: "Referral",
    navigate: "referral",
  },
];

export const formOneData: any[] = [
  {
    que: "Are you diabetic?",
    y: "Yes",
    n: "No",
    queId: 1,
    isY: false,
    isN: false,
    yesId: 1,
    noId: 1,
  },
  {
    que: "Are you married?",
    y: "Yes",
    n: "No",
    queId: 2,
    isY: false,
    isN: false,
    yesId: 2,
    noId: 2,
  },
  {
    que: "Are you suffering from chronic disease?",
    y: "Yes",
    n: "No",
    queId: 3,
    isY: false,
    isN: false,
    yesId: 3,
    noId: 3,
  },
];

export const formTwoData: any[] = [
  {
    que: "Do you suffer from indigestion?",
    y: "Yes",
    n: "No",
    queId: 1,
    isY: false,
    isN: false,
    yesId: 1,
    noId: 1,
  },
  {
    que: "Are you often sick to your stomach?",
    y: "Yes",
    n: "No",
    queId: 2,
    isY: false,
    isN: false,
    yesId: 2,
    noId: 2,
  },
  {
    que: "Is your appetite always poor?",
    y: "Yes",
    n: "No",
    queId: 3,
    isY: false,
    isN: false,
    yesId: 3,
    noId: 3,
  },
];

export const formThreeData: any[] = [
  {
    que: "Are your joints often painfully swollen? ",
    y: "Yes",
    n: "No",
    queId: 1,
    isY: false,
    isN: false,
    yesId: 1,
    noId: 1,
  },
  {
    que: "Is your skin very sensitive or tender?",
    y: "Yes",
    n: "No",
    queId: 2,
    isY: false,
    isN: false,
    yesId: 2,
    noId: 2,
  },
  {
    que: "Does your skin often break out in a rash?",
    y: "Yes",
    n: "No",
    queId: 3,
    isY: false,
    isN: false,
    yesId: 3,
    noId: 3,
  },
];
export const AdminHeader: any[] = [
  {
    Header: () => {
      return (
        <div>
          <p>AGENT</p>
          <p>CODE</p>
        </div>
      );
    },
    accessor: "agentcode",
  },
  {
    Header: "AGENT",
    accessor: "agent",
  },
  {
    Header: () => {
      return (
        <div>
          <p>LANGUAGES</p>
          <p>KNOWN</p>
        </div>
      );
    },
    accessor: "languagesknown",
  },
  {
    Header: () => {
      return (
        <div>
          <p>TOTAL</p>
          <p>LEADS</p>
        </div>
      );
    },
    accessor: "totalleads",
  },
  {
    Header: () => {
      return (
        <div>
          <p>CALL</p>
          <p>LEADS</p>
        </div>
      );
    },
    accessor: "callleads",
  },
  {
    Header: () => {
      return (
        <div>
          <p>FOLLOW</p>
          <p>UP</p>
        </div>
      );
    },
    accessor: "followup",
  },
  {
    Header: "REMAINING",
    accessor: "remaining",
  },
  {
    Header: "CONVERSION",
    accessor: "conversion",
  },
  {
    Header: "STATUS",
    Cell: (props: any) => {
      return (
        <>
          <span
            style={{
              color: "#02BF90",
              cursor: "pointer",
              fontSize: "var(--font-12)",
              fontWeight: "var(--font-normal)",
            }}
          >
            Active
          </span>
        </>
      );
    },
  },
  {
    Header: "DETAILS",
    Cell: (props: any) => {
      return (
        <>
          <span
            style={{
              color: "var(--blue1)",
              cursor: "pointer",
              fontSize: "var(--font-12)",
              fontWeight: "var(--font-normal)",
            }}
            onClick={() => props.onClick()}
          >
            VIEW
          </span>
        </>
      );
    },
  },
  {
    Header: "ASSIGN",
    Cell: (props: any) => {
      return (
        <>
          <span
            style={{
              color: "var(--blue1)",
              cursor: "pointer",
              fontSize: "var(--font-12)",
              fontWeight: "var(--font-normal)",
            }}
            onClick={() => props.onRowClick()}
          >
            VIEW
          </span>
        </>
      );
    },
  },
];
export const AgentHeader: any[] = [
  {
    Header: () => {
      return (
        <div>
          <p>AGENT</p>
          <p>CODE</p>
        </div>
      );
    },
    accessor: "agentcode",
  },
  {
    Header: "AGENT",
    accessor: "agent",
  },
  {
    Header: () => {
      return (
        <div>
          <p>LANGUAGES</p>
          <p>KNOWN</p>
        </div>
      );
    },
    accessor: "languagesknown",
  },

  {
    Header: "STATUS",
    Cell: (props: any) => {
      //   const noteDetail = props?.row?.original?.attachements;
      return (
        <>
          <span
            style={{
              color: "#02BF90",
              cursor: "pointer",
              fontSize: "var(--font-12)",
              fontWeight: "var(--font-normal)",
            }}
          >
            Active
          </span>
        </>
      );
    },
  },

  {
    Header: "DETAILS",
    Cell: (props: any) => {
      return (
        <>
          <span
            style={{
              color: "var(--blue1)",
              cursor: "pointer",
              fontSize: "var(--font-12)",
              fontWeight: "var(--font-normal)",
            }}
            onClick={() => props.onClick()}
          >
            VIEW
          </span>
        </>
      );
    },
  },
  {
    Header: "ASSIGN",
    Cell: (props: any) => {
      //   const noteDetail = props?.row?.original?.attachements;
      return (
        <>
          <span
            style={{
              color: "var(--blue1)",
              cursor: "pointer",
              fontSize: "var(--font-12)",
              fontWeight: "var(--font-normal)",
            }}
            onClick={() => props.onRowClick()}
          >
            VIEW
          </span>
        </>
      );
    },
  },
];
export const AdminRow: any[] = [
  {
    agentcode: "C-101",
    agent: "Vivinne King",
    languagesknown: "English, Arabic, Hindi",
    totalleads: "10",
    callleads: "10",
    followup: "10",
    remaining: "10",
    conversion: "10",
  },
  {
    agentcode: "C-101",
    agent: "Vivinne King",
    languagesknown: "English, Arabic, Hindi",
    totalleads: "10",
    callleads: "10",
    followup: "10",
    remaining: "10",
    conversion: "10",
  },
  {
    agentcode: "C-101",
    agent: "Vivinne King",
    languagesknown: "English, Arabic, Hindi",
    totalleads: "10",
    callleads: "10",
    followup: "10",
    remaining: "10",
    conversion: "10",
  },
  {
    agentcode: "C-101",
    agent: "Vivinne King",
    languagesknown: "English, Arabic, Hindi",
    totalleads: "10",
    callleads: "10",
    followup: "10",
    remaining: "10",
    conversion: "10",
  },
  {
    agentcode: "C-101",
    agent: "Vivinne King",
    languagesknown: "English, Arabic, Hindi",
    totalleads: "10",
    callleads: "10",
    followup: "10",
    remaining: "10",
    conversion: "10",
  },
];
export const AssignHeader: any[] = [
  {
    Header: "LEAD NAME",
    accessor: "leadname",
  },
  {
    Header: "DEPARTMENT",
    accessor: "department",
  },

  {
    Header: "DELEGATE",
    Cell: (props: any) => {
      return (
        <>
          <CheckIcon fillColor={colors.green1} />
        </>
      );
    },
  },
];
export const AssignRow: any[] = [
  {
    leadname: "-",
    department: "-",
  },
];
export const agentleadsTabData: ITab[] = [
  {
    id: 0,
    name: t("Header Title.Leads"),
    navigate: "agentleads",
  },
  {
    id: 1,
    name: t("Header Title.Follow Up"),
    navigate: "follow-up",
  },
];

export const crmAdminTabData: ITab[] = [
  {
    id: 0,
    name: t("IPDConsultation.New"),
    navigate: "new",
  },
  {
    id: 1,
    name: t("CRMAdmin.Sent"),
    navigate: "sent",
  },
];

export const gender_array = [
  { label: "All", value: "" },
  { label: "Internal", value: "INTERNAL" },
  { label: "External", value: "EXTERNAL" },
];

export const masterUnitTypeData: any = [
  // {
  //   Header: 'ID',
  //   accessor: '_id',
  // },
  {
    Header: "UNIT TYPE",
    accessor: "value",
  },

  {
    Header: "QTY",
    Cell: (cell: any) => {
      const qty = cell?.row?.original?.metadata?.qty;
      return (
        <>
          <p>{qty}</p>
        </>
      );
    },
    accessor: "qty",
  },
  {
    Header: "ACTIVE STATUS",
    Cell: (props: any) => {
      const is_active = props?.row?.original?.is_active;
      return (
        <ToggleSwitchV2
          isToggled={is_active}
          handleToggle={() => props.onClick(props?.row?.original)}
        />
      );
    },
  },
  {
    Header: "ACTION",
    Cell: ({ row }: any) => {
      const dispatch = useAppDispatch();
      const handleEdit = (item: any) => {
        dispatch(getAllMasterValuePayloadData(item));
      };
      return (
        <EditIcon
          fillColor={colors.grey4}
          handleClick={() =>
            row?.original?.is_active && handleEdit(row?.original)
          }
        />
      );
    },
  },
];

export const AgentsFloatingBarData: IFormActionSidebar[] = [
  {
    id: 0,
    name: "Add",
    icon: AddIcon,
  },
  {
    id: 1,
    name: "Save",
    icon: SaveIcon,
  },
  {
    id: 2,
    name: "Delete",
    icon: DeleteIcon,
  },
  {
    id: 3,
    name: "Print",
    icon: PrintFormIcon,
  },
  {
    id: 4,
    name: "Exit",
    icon: ExitIcon,
  },
];
export const roleTypeDropdown = [
  {
    label: "Primary",
    value: "primary",
  },
  {
    label: "Secondary",
    value: "secondary",
  },
];

// const [showDetailPopup, setShowDetailPopup] = useState<boolean>(false);
// const [DetailPopData, setDetailPopData] = useState({});
// {showDetailPopup && (
//   <Popup
//     Children={Criteria}
//     popData={notesPopData}
//     handleClose={() => handledatas()} />
// )}

// receptionist IPD Tab data
export const receptionistIPDTabData: ITab[] = [
  {
    id: 0,
    name: t("IPDInvoice.IPDInfo"),
    navigate: null,
    activeLocation: "/ipd-invoice/patientinfo",
  },
  {
    id: 1,
    name: t("IPDInvoice.Consumable"),
    navigate: null,
    activeLocation: "/ipd-invoice/consumble",
  },
  {
    id: 2,
    name: t("IPDInvoice.Charges"),
    navigate: null,
    activeLocation: "/ipd-invoice/charges",
  },
  {
    id: 3,
    name: t("InsurancePlan_Form.Services"),
    navigate: null,
    activeLocation: "/ipd-invoice/services",
  },
  {
    id: 4,
    name: t("InvoicePayment.Payment"),
    navigate: null,
    activeLocation: "/ipd-invoice/payment",
  },
];
export const ipdTimelineTabData: ITabV2[] = [
  {
    id: 0,
    name: t("IPDTimeline.Consultation"),
    children: (
      <IpdTimelineMainLayout
        heading={t("IPDTimeline.Consultation") || "Consultation"}
        childern={<Consultation />}
      />
    ),
    active: true,
  },
  {
    id: 1,
    name: t("LabJob.Tests"),
    children: (
      <IpdTimelineMainLayout
        heading={t("LabJob.Tests") || "Tests"}
        childern={<IpdTest />}
      />
    ),
    active: false,
  },
  {
    id: 2,
    name: t("Common.Medication"),
    children: (
      <IpdTimelineMainLayout
        heading={t("Common.Medication") || "Medication"}
        childern={<IpdMedication />}
      />
    ),
    active: false,
  },
  {
    id: 3,
    name: t("IPDTimeline.Nurse Notes"),
    children: (
      <IpdTimelineMainLayout
        heading={t("IPDTimeline.Nurse Notes") || "Nurse Notes"}
        childern={
          <h1 style={{ textAlign: "center" }}>
            {t("Common.No records found")}
          </h1>
        }
      />
    ),
    active: false,
  },
];

export const caladerDropdownData = [
  {
    _id: "ter6e76er4",
    name: "Doctor",
    navigate: "",
  },
  {
    _id: "ter6e76ed7",
    name: "Room",
    navigate: "room",
  },
  {
    _id: "43434fddf",
    name: "IPD Room/Bed",
    navigate: "beds",
  },
  // {
  //   _id: "re45435r4",
  //   name: "Nurse",
  //   navigate: null,
  // },
];

export const widgetDatefilterData = [
  {
    label: "Yearly",
    value: "yearly",
    key: "YEARLY",
  },
  {
    label: "Monthly",
    value: "monthly",
    key: "MONTHLY",
  },
  {
    label: "Custom",
    value: "Custom",
    key: "CUSTOM",
  },
];
export const caladerDropdownDataWithoutBed = [
  {
    _id: "ter6e76er4",
    name: "Doctor",
    navigate: "",
  },
  {
    _id: "ter6e76ed7",
    name: "Room",
    navigate: "room",
  },
  {
    _id: "re45435r4",
    name: "Nurse",
    navigate: null,
  },
];

export const leadTabData: ITab[] = [
  {
    id: 0,
    name: t("HeaderPopup.Total Leads"),
    navigate: "leads",
  },
  {
    id: 1,
    name: t("InvoiceInfo.Internal"),
    navigate: "internal",
  },
  {
    id: 2,
    name: t("InvoiceInfo.External"),
    navigate: "external",
  },
];

export const campaignLabel: any = {
  [NEW]: "New",
  [ON_GOING]: "On-going",
  [COMPLETED]: "Completed",
};

export const csvFileData = [
  {
    name: "Daffy Duck",
    age: "24",
    tags: "a b c d",
    phone: "12345678",
    gender: "MALE",
    nationality: "kuwaiti",
  },
  {
    name: "Bugs Bunny",
    age: "24",
    tags: "a b c d",
    phone: "12345678",
    gender: "MALE",
    nationality: "kuwaiti",
  },
];

export const countryList: any = [
  "ABW",
  "AFG",
  "AFG",
  "AFG",
  "AGO",
  "AIA",
  "ALA",
  "ALB",
  "AND",
  "ARE",
  "ARG",
  "ARM",
  "ASM",
  "ATA",
  "ATF",
  "ATG",
  "AUS",
  "AUT",
  "AZE",
  "BDI",
  "BEL",
  "BEN",
  "BES",
  "BFA",
  "BGD",
  "BGR",
  "BHR",
  "BHS",
  "BIH",
  "BLM",
  "BLR",
  "BLZ",
  "BMU",
  "BOL",
  "BRA",
  "BRB",
  "BRN",
  "BTN",
  "BVT",
  "BWA",
  "CAF",
  "CAN",
  "CCK",
  "CHE",
  "CHL",
  "CHN",
  "CIV",
  "CMR",
  "COD",
  "COG",
  "COK",
  "COL",
  "COM",
  "CPV",
  "CRI",
  "CUB",
  "CUW",
  "CXR",
  "CYM",
  "CYP",
  "CZE",
  "DEU",
  "DJI",
  "DMA",
  "DNK",
  "DOM",
  "DZA",
  "ECU",
  "EGY",
  "ERI",
  "ESH",
  "ESP",
  "EST",
  "ETH",
  "FIN",
  "FJI",
  "FLK",
  "FRA",
  "FRO",
  "FSM",
  "GAB",
  "GBR",
  "GEO",
  "GGY",
  "GHA",
  "GIB",
  "GIN",
  "GLP",
  "GMB",
  "GNB",
  "GNQ",
  "GRC",
  "GRD",
  "GRL",
  "GTM",
  "GUF",
  "GUM",
  "GUY",
  "HKG",
  "HMD",
  "HND",
  "HRV",
  "HTI",
  "HUN",
  "IDN",
  "IMN",
  "IND",
  "IOT",
  "IRL",
  "IRN",
  "IRQ",
  "ISL",
  "ISR",
  "ITA",
  "JAM",
  "JEY",
  "JOR",
  "JPN",
  "KAZ",
  "KEN",
  "KGZ",
  "KHM",
  "KIR",
  "KNA",
  "KOR",
  "KWT",
  "LAO",
  "LBN",
  "LBR",
  "LBY",
  "LCA",
  "LIE",
  "LKA",
  "LSO",
  "LTU",
  "LUX",
  "LVA",
  "MAC",
  "MAF",
  "MAR",
  "MCO",
  "MDA",
  "MDG",
  "MDV",
  "MEX",
  "MHL",
  "MKD",
  "MLI",
  "MLT",
  "MMR",
  "MNE",
  "MNG",
  "MNP",
  "MOZ",
  "MRT",
  "MSR",
  "MTQ",
  "MUS",
  "MWI",
  "MYS",
  "MYT",
  "NAM",
  "NCL",
  "NER",
  "NFK",
  "NGA",
  "NIC",
  "NIU",
  "NLD",
  "NOR",
  "NPL",
  "NRU",
  "NZL",
  "OMN",
  "PAK",
  "PAN",
  "PCN",
  "PER",
  "PHL",
  "PLW",
  "PNG",
  "POL",
  "PRI",
  "PRK",
  "PRT",
  "PRY",
  "PSE",
  "PYF",
  "QAT",
  "REU",
  "ROU",
  "RUS",
  "RWA",
  "SAU",
  "SDN",
  "SEN",
  "SGP",
  "SGS",
  "SHN",
  "SJM",
  "SLB",
  "SLE",
  "SLV",
  "SMR",
  "SOM",
  "SPM",
  "SRB",
  "SSD",
  "STP",
  "SUR",
  "SVK",
  "SVN",
  "SWE",
  "SWZ",
  "SXM",
  "SYC",
  "SYR",
  "TCA",
  "TCD",
  "TGO",
  "THA",
  "TJK",
  "TKL",
  "TKM",
  "TLS",
  "TON",
  "TTO",
  "TUN",
  "TUR",
  "TUV",
  "TWN",
  "TZA",
  "UGA",
  "UKR",
  "UMI",
  "URY",
  "USA",
  "UZB",
  "VAT",
  "VCT",
  "VEN",
  "VGB",
  "VIR",
  "VNM",
  "VUT",
  "WLF",
  "WSM",
  "YEM",
  "ZAF",
  "ZMB",
  "ZWE",
];

export const reactSelectStyle = {
  menuList: (base: any) => ({
    ...base,

    "::-webkit-scrollbar": {
      width: "4px",
      height: "0px",
    },
    "::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#a49e9e",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#a49e9e",
    },
  }),
};

export const blackListPath = [
  "/patientdiagnosis/treatment",
  "/patientdiagnosis/medication",
  "/patientdiagnosis/request",
  "/patientdiagnosis/referral",
];

export const dayRangeData = [
  {
    value: "Today",
    name: "today",
  },
  {
    value: "Weekly",
    name: "weekly",
  },
  {
    value: "Monthly",
    name: "monthly",
  },
];

export const hourDropdown: { label: string; value: string }[] = [
  {
    label: "00",
    value: "00",
  },
  {
    label: "01",
    value: "01",
  },
  {
    label: "02",
    value: "02",
  },
  {
    label: "03",
    value: "03",
  },
  {
    label: "04",
    value: "04",
  },
  {
    label: "05",
    value: "05",
  },
  {
    label: "06",
    value: "06",
  },
  {
    label: "07",
    value: "07",
  },
  {
    label: "08",
    value: "08",
  },
  {
    label: "09",
    value: "09",
  },
  {
    label: "10",
    value: "10",
  },
  {
    label: "11",
    value: "11",
  },
  {
    label: "12",
    value: "12",
  },
  {
    label: "13",
    value: "13",
  },
  {
    label: "14",
    value: "14",
  },
  {
    label: "15",
    value: "15",
  },
  {
    label: "16",
    value: "16",
  },
  {
    label: "17",
    value: "17",
  },
  {
    label: "18",
    value: "18",
  },
  {
    label: "19",
    value: "19",
  },
  {
    label: "20",
    value: "20",
  },
  {
    label: "21",
    value: "21",
  },
  {
    label: "22",
    value: "22",
  },
  {
    label: "23",
    value: "23",
  },
];

export const meridiemData = [
  {
    label: "AM",
    value: "AM",
  },
  {
    label: "PM",
    value: "PM",
  },
];

export const minDropdown: { label: string; value: string }[] = [
  {
    label: "00",
    value: "00",
  },
  {
    label: "15",
    value: "15",
  },
  {
    label: "30",
    value: "30",
  },
  {
    label: "45",
    value: "45",
  },
  {
    label: "59",
    value: "59",
  },
];

export const departmentsTableHeaderData: any = [
  // {
  //   Header: 'SR.NO',
  //   accessor: 'srno',
  // },
  {
    Header: t("InsuranceHeader.DEPARTMENTS NAME"),
    accessor: "departments_name",
  },
  {
    Header: t("HrDashboard.DESIGNATIONS"),
    accessor: "designations",
  },
  {
    Header: t("DocUploadHeader.ACTION"),
    Cell: () => {
      return (
        <div className={styles.employeeTableActions}>
          <EditIcon fillColor={colors.grey4} customClass={styles.deleteIcon} />
        </div>
      );
    },
  },
];

export const departmnetsTableData: any[] = [
  {
    srno: "1",
    departments_name: "Technical Support",
    designations: "Assistant",
  },
  {
    srno: "",
    departments_name: "",
    designations: "Manager",
  },
  {
    srno: "",
    departments_name: "",
    designations: "Assistant Manager",
  },
  {
    srno: "",
    departments_name: "",
    designations: "Assistant Manager2",
  },
  {
    srno: "2",
    departments_name: "Marketing",
    designations: "Marketing Manager",
  },
  {
    srno: "3",
    departments_name: "Finance",
    designations: "Fresher Human Resource",
  },
];
interface IOptionType {
  label: string;
  value: string | boolean | number;
}

export const statusOptions: IOptionType[] = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];
export const monthOptions: IOptionType[] = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

export const PaymentArray = ["PAID", "UNPAID"];

export const EmployeeArray = [
  "Employee 1",
  "Employee 2",
  "Employee 3",
  "Employee 4",
];

export const rollOptions = [
  { value: "Paid", label: "Paid" },
  { value: "UnPaid", label: "UnPaid" },
  { value: "Sick", label: "Sick" },
  { value: "Casual", label: "Casual" },
  { value: "Earned", label: "Earned" },

  { value: "None", label: "None" },
];

export const salaryTypeOptions: IOptionType[] = [
  { value: "649e843bf4a59b3ee67cac9c", label: "Hourly" },
  { value: "649407ca5edf85438d94632c", label: "Monthly" },
];

export const employeeleaveData = [
  {
    Header: t("RcptTableHeader.DATE"),
    accessor: (row: any) => {
      return moment(row.date).format("DD MMM YYYY") ?? "-";
    },
  },
  {
    Header: t("Attendance.PRESENT"),
    accessor: (row: any) => {
      const noteDetail = row;
      return (
        <>
          {noteDetail?.attendance === "PRESENT" ? (
            <PresentIcon />
          ) : noteDetail?.isPaid === true ? (
            <p className={styles.leaveStyle}>L</p>
          ) : (
            <AbsentIcon />
          )}
        </>
      );
    },
  },
  {
    Header: t("Attendance.PUNCH_IN"),
    accessor: (row: any) => {
      return row?.start_time === undefined
        ? "-"
        : moment(row.start_time).utc().format("HH:mm");
    },
  },
  {
    Header: t("Attendance.PUNCH_OUT"),
    accessor: (row: any) => {
      return row.end_time === undefined
        ? "-"
        : moment(row.end_time).utc().format("HH:mm");
    },
  },
  {
    Header: t("AllImagesHeader.VIEW"),
    Cell: (props: any) => {
      const notesObject = {
        // noteDetail: props?.row?.original?.remark,
        noteDetail: props?.row.reason,
      };
      return (
        <>
          {notesObject?.noteDetail ? (
            <span
              style={{
                color: "var(--blue1)",
                cursor: "pointer",
                fontSize: "var(--font-12)",
                fontWeight: "var(--font-normal)",
              }}
              onClick={() => props.onClick(notesObject)}
            >
              {t("Common.View")}
            </span>
          ) : (
            "-"
          )}
        </>
      );
    },
  },
];

export const StatusArray = ["PAID", "UNPAID"];

export const level2TabData: ITab[] = [
  {
    id: 0,
    name: t("ViewChartOfAccount.Level2"),
    navigate: null,
    activeLocation: "/viewchartofaccounts/level2list",
  },
  {
    id: 1,
    name: t("ViewChartOfAccount.Level3"),
    navigate: null,
    activeLocation: "/viewchartofaccounts/level3list",
  },
  {
    id: 2,
    name: t("ViewChartOfAccount.Level4"),
    navigate: null,
    activeLocation: "/viewchartofaccounts/level4list",
  },
  {
    id: 3,
    name: t("ViewChartOfAccount.Level5"),
    navigate: null,
    activeLocation: "/viewchartofaccounts/level5list",
  },
];

export const level2TableHeader: any = [
  {
    Header: t("Add Insurance Table Data.ID"),
    Cell: (props: any) => {
      return (
        <>
          <span
            className={
              props?.row?.original?.isFinalLevel
                ? styles.idBoldStyle
                : styles.handTool
            }
          >
            {props?.row?.original?.code ?? "-"}
          </span>
        </>
      );
    },
  },
  {
    Header: t("AllAttachmentHeader.NAME"),
    Cell: (props: any) => {
      return (
        <>
          <span
            className={
              props?.row?.original?.isFinalLevel
                ? styles.boldStyle
                : styles.handTool
            }
          >
            {props?.row?.original?.name ?? "-"}
          </span>
        </>
      );
    },
  },
  {
    Header: t("RequestDiagnosis.ACTIONS"),
    Cell: (props: any) => {
      return (
        <EditIcon
          fillColor={colors.grey1}
          customClass={styles.editIcon}
          handleClick={(e: any) => {
            e.stopPropagation();
            props.onClick(props?.row?.original);
          }}
        />
      );
    },
  },
];

export const level3TableHeader: any = [
  {
    Header: t("Add Insurance Table Data.ID"),
    Cell: (props: any) => {
      return (
        <>
          <span
            className={
              props?.row?.original?.isFinalLevel
                ? styles.idBoldStyle
                : styles.handTool
            }
          >
            {props?.row?.original?.code ?? "-"}
          </span>
        </>
      );
    },
  },
  {
    Header: t("AllAttachmentHeader.NAME"),
    Cell: (props: any) => {
      return (
        <>
          <span
            className={
              props?.row?.original?.isFinalLevel
                ? styles.boldStyle
                : styles.handTool
            }
          >
            {props?.row?.original?.name ?? "-"}
          </span>
        </>
      );
    },
  },
  {
    Header: t("RequestDiagnosis.ACTIONS"),
    Cell: (props: any) => {
      return (
        <EditIcon
          fillColor={colors.grey1}
          customClass={styles.editIcon}
          handleClick={(e: any) => {
            e.stopPropagation();
            props.onClick(props?.row?.original);
          }}
        />
      );
    },
  },
];

export const level4TableHeader: any = [
  {
    Header: t("Add Insurance Table Data.ID"),
    Cell: (props: any) => {
      return (
        <>
          <span
            className={
              props?.row?.original?.isFinalLevel
                ? styles.idBoldStyle
                : styles.handTool
            }
          >
            {props?.row?.original?.code ?? "-"}
          </span>
        </>
      );
    },
  },
  {
    Header: t("AllAttachmentHeader.NAME"),
    Cell: (props: any) => {
      return (
        <>
          <span
            className={
              props?.row?.original?.isFinalLevel
                ? styles.boldStyle
                : styles.handTool
            }
          >
            {props?.row?.original?.name ?? "-"}
          </span>
        </>
      );
    },
  },
  {
    Header: t("RequestDiagnosis.ACTIONS"),
    Cell: (props: any) => {
      return (
        <EditIcon
          fillColor={colors.grey1}
          customClass={styles.editIcon}
          handleClick={(e: any) => {
            e.stopPropagation();
            props.onClick(props?.row?.original);
          }}
        />
      );
    },
  },
];

export const level5TableHeader: any = [
  {
    Header: t("Add Insurance Table Data.ID"),
    Cell: (props: any) => {
      return (
        <>
          <span
            className={
              props?.row?.original?.isFinalLevel
                ? styles.idBoldStyle
                : styles.handTool
            }
          >
            {props?.row?.original?.code ?? "-"}
          </span>
        </>
      );
    },
  },
  {
    Header: t("AllAttachmentHeader.NAME"),
    Cell: (props: any) => {
      return (
        <>
          <span
            className={
              props?.row?.original?.isFinalLevel
                ? styles.boldStyle
                : styles.handTool
            }
          >
            {props?.row?.original?.name ?? "-"}
          </span>
        </>
      );
    },
  },
  {
    Header: t("RequestDiagnosis.ACTIONS"),
    Cell: (props: any) => {
      return (
        <EditIcon
          fillColor={colors.grey1}
          customClass={styles.editIcon}
          handleClick={(e: any) => {
            e.stopPropagation();
            props.onClick(props?.row?.original);
          }}
        />
      );
    },
  },
];

export const AssetsArray = ["Debit", "Credit"];

export const costCenterOptions = [
  { value: "Branch", label: "Branch", isdisabled: false },
  { value: "Department", label: "Department", isdisabled: false },
  { value: "Doctor", label: "Doctor", isdisabled: false },
];

export const voucherStatusOptions = ["NON-POSTED", "POSTED", "UPDATED"];

export const voucherStatusFilterOptions = [
  {
    label: "All status",
    value: "",
  },
  {
    label: "NON-POSTED",
    value: "NON-POSTED",
  },
  {
    label: "POSTED",
    value: "POSTED",
  },
  {
    label: "UPDATED",
    value: "UPDATED",
  },
];

export const reportTabData: ITab[] = [
  {
    id: 0,
    name: t("Reports.Ledger"),
    navigate: "ledger",
  },
  {
    id: 1,
    name: t("Reports.Trial_Balance"),
    navigate: "trialbalance",
  },
  {
    id: 2,
    name: t("Reports.PL"),
    navigate: "pl",
  },
  {
    id: 3,
    name: t("Reports.Balance_Sheet"),
    navigate: "balancesheet",
  },
];

export const unavailabilityTabData: ITab[] = [
  {
    id: 0,
    name: t("Receptionist Dashboard.Doctor"),
    navigate: "doctor",
  },
  {
    id: 1,
    name: t("IPDBooking.Room"),
    navigate: "rooms",
  },
];

export const isBoldRow = ["one", "two"];
export const isBoldRowiWithTotal = ["one", "two", "total"];

export const kpiRangeData = [
  {
    label: "Weekly",
    value: "WEEKLY",
  },
  {
    label: "Monthly",
    value: "MONTHLY",
  },
  {
    label: "Yearly",
    value: "YEARLY",
  },
];

export const defaultSeederAppointmentStatus: string[] = [
  "Pending",
  "Inprogress",
  "Arrived",
  "No Show",
  "Completed",
  "Waitinglist",
  "Rescheduled",
  "Cancelled",
  "Scheduled",
  "Booked",
  "No Answer",
];

export const scheduledExclude = [
  "SCHEDULED",
  "PENDING",
  "INPROGRESS",
  "COMPLETED",
  "WAITINGLIST",
  // "BOOKED",
  // "ARRIVED",
];

export const inprogressExclude = [
  "PENDING",
  "INPROGRESS",
  // "ARRIVED",
  "NOSHOW",
  "WAITINGLIST",
  "RESCHEDULED",
  "CANCELLED",
  "SCHEDULED",
  "BOOKED",
  "NOANSWER",
];

export const arrivedExclude = [
  "PENDING",
  "ARRIVED",
  "COMPLETED",
  "WAITINGLIST",
  "SCHEDULED",
  "BOOKED",
  "NOANSWER",
];

export const bookedExclude = [
  "PENDING",
  "INPROGRESS",
  // "ARRIVED",
  "NOSHOW",
  "COMPLETED",
  "WAITINGLIST",
  "BOOKED",
  "NOANSWER",
];

export const noanswerExclude = [
  "PENDING",
  "INPROGRESS",
  // "ARRIVED",
  "NOSHOW",
  "COMPLETED",
  "WAITINGLIST",
  "BOOKED",
  "NOANSWER",
];

export const rescheduledExclude = [
  "PENDING",
  "INPROGRESS",
  "COMPLETED",
  "WAITINGLIST",
  "BOOKED",
  // "ARRIVED",
];
export const defaultExclude = [
  "PENDING",
  "INPROGRESS",
  // "ARRIVED",
  "NOSHOW",
  "COMPLETED",
  "WAITINGLIST",
  "RESCHEDULED",
  "CANCELLED",
  "NOANSWER",
];

export const pendingExclude = [
  "INPROGRESS",
  // "ARRIVED",
  "NOSHOW",
  "COMPLETED",
  "RESCHEDULED",
  "BOOKED",
  "NOANSWER",
];
const Schedule: string = "SCHEDULED";
const Inprogress: string = "INPROGRESS";
const Arrived: string = "ARRIVED";
const booked: string = "BOOKED";
const noAnswer: string = "NOANSWER";
const Rescheduled: string = "RESCHEDULED";
export const Pending: string = "PENDING";
export const defaultBooking: string = "DEFAULT";

export const matchExclude = {
  [Schedule]: scheduledExclude,
  [Inprogress]: inprogressExclude,
  [Arrived]: arrivedExclude,
  [booked]: bookedExclude,
  [noAnswer]: noanswerExclude,
  [Rescheduled]: rescheduledExclude,
  [defaultBooking]: defaultExclude,
  [Pending]: pendingExclude,
};

export const ReportType = [
  {
    name: "Patient",
    report: [
      "Patient Source",
      "Patient Outstanding",
      "Patient List",
      "Patient Statement",
    ],
  },
  {
    name: "Sales",
    report: ["Invoice Wise Sales Summary", " Service Wise Sales Summary"],
  },
  {
    name: "Department",
    report: ["Department Report"],
  },
  {
    name: "Doctor",
    report: ["Doctor Report"],
  },
  {
    name: "Collections",
    report: ["User Wise Collections Summary", "Day Wise Collections Summary"],
  },
  {
    name: "Summary",
    report: ["Card Summary"],
  },
];

export const widgetsList = [
  PATIENT_COMPARISON,
  APPOINTMENT_OCCUPANCY,
  PATIENT_SUMMARY,
  PATIENT_FEEDBACK,
  DOCTOR_FEEDBACK,
  // DOCTOR_OCCUPANCY,
  PATIENT_VISIT,
  // ABSENT_TODAY,
  INVENTORY_ITEMS,
  INVENTORY_DEPARTMENT_REQUESTS,
  DOCTOR_REVENUE,
  DOCTOR_OUTSTANDING,
  DEPARTMENT_REVENUE,
  IPD_CASE_SUMMARY,
  LAB_JOBS,
  RADIOLOGY_JOBS,
  PHARMACY_SUMMARY,
  ACCOUNT_SUMMARY,
];

export const ongoingPlansStatusFilter = [
  {
    label: "All",
    value: "",
  },
  {
    label: "New",
    value: "new",
  },
  {
    label: "Attended",
    value: "attended",
  },
];

export const ongoingPlansBillableFilter = [
  {
    label: "All",
    value: "",
  },
  {
    label: "To Be Billed",
    value: "to-be-billed",
  },
  {
    label: "Not Billed",
    value: "not-billed",
  },
];

export const appointmentSlotSizes = [
  {
    label: "15 Minutes",
    value: "quarterHour",
  },
  {
    label: "30 Minutes",
    value: "halfHour",
  },
];
